<template>
    <!--届け先指定パーツ-->
    <div class="sh030" id="sh030" v-cloak>
        <loading :active.sync="isLoading" 
            :can-cancel="false"
            :background-color="'transparent'">
        </loading>
        <!-- ご注文手続き -->
        <div class="itemTitle">
            <h2>{{$t("sh030.labels.orderProcedure")}}</h2>
        </div>
        <div class="section-inner">
            <!--エラーメッセージ表示 -->
            <div class="errMessage">
                <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="SH030_PART"/>
            </div>

            <!--注文者情報 ゲストまたは代理の時に表示 -->
            <div class="subTitle" v-if="dataInit.kokyakuNo == 999999999 || dataInit.dairiInputKbn == '1'">
                <h4>{{$t("sh030.labels.orderInfo")}}</h4>
            </div>

            <!-- 代理注文者 -->
            <div class="sh030-body-dairiOrder" v-if="dataInit.dairiInputKbn == '1'">
                <!-- ログインユーザーの注文 -->
                <label for="radiogroup_21" class="select_add">
                    <input type="radio" id="radiogroup_21" name="radioGroup3" value="1" v-model="reqModel.radioGroup3" @click="radioDairiClick(1)" class="margin-left-10px">
                    <b> {{$t("sh030.labels.sendOrderUser")}}</b>
                </label>
                <!-- 代理入力〇〇の注文 -->
                <label for="radiogroup_22" class="select_add">
                    <input type="radio" id="radiogroup_22" name="radioGroup3" value="2" v-model="reqModel.radioGroup3" @click="radioDairiClick(2)"  class="margin-left-10px">
                    <b> {{$t("sh030.labels.sendOtherOrder[0]")}}{{dataInit.dairiNm}}{{$t("sh030.labels.sendOtherOrder[1]")}}</b>
                </label>

                <!--ログインユーザー -->
                <table class="sh030-body-dairiOrder-tbl-person sh030-body-dairiOrder-tbl-mb32" v-if="reqModel.radioGroup3 == '1'">
                    <tr>
                        <!--注文者名-->
                        <th>{{dataInit.dairiNm}}{{$t("sh030.labels.orderNm")}}</th>
                        <td>
                            {{reqModel.dairiKokyakuNm1}} {{reqModel.dairiKokyakuNm2}}
                        </td>
                    </tr>
                    <tr>
                        <!-- 注文者住所 -->
                        <th>{{dataInit.dairiNm}}{{$t("sh030.labels.orderAddr")}}</th>
                        <td>
                            〒{{reqModel.dairiKokyakuZip}}
                            <p>{{reqModel.dairiKokyakuAddr1}}
                                <br>
                                {{reqModel.dairiKokyakuAddr2}}
                                <br>
                                {{reqModel.dairiKokyakuAddr3}}
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <!-- 注文者電話番号 -->
                        <th>{{dataInit.dairiNm}}{{$t("common.labels.phoneNumber")}}</th>
                        <td>
                            {{reqModel.dairiKokyakuTelNo}}
                        </td>
                    </tr>
                </table>
                <!--別の注文者 -->
                <table class="sh030-body-dairiOrder-tbl-person sh030-body-dairiOrder-tbl-mb32" v-else-if="reqModel.radioGroup3 == '2'">
                    <tr>
                        <!-- 注文者 -->
                        <th>{{dataInit.dairiNm}}</th>
                        <td>
                            {{reqModel.kokyakuCd}}&nbsp;
                            <!-- 店舗を検索-->
                            <button class="btn btn-secondary btn-dairinm-css" type="button"
                                    @click="searchDairiList()">{{dataInit.dairiNm}}{{$t("sh030.buttons.searchTenpo")}}</button>
                        </td>
                    </tr>
                    <tr v-if="showBetuOrder">
                        <!--注文者名-->
                        <th>{{dataInit.dairiNm}}{{$t("sh030.labels.orderNm")}}</th>
                        <td>
                            {{reqModel.kokyakuNm1}} {{reqModel.kokyakuNm2}}
                        </td>
                    </tr>
                    <tr v-if="showBetuOrder">
                        <!-- 注文者住所 -->
                        <th>{{dataInit.dairiNm}}{{$t("sh030.labels.orderAddr")}}</th>
                        <td v-if="reqModel.kokyakuZip != '' && reqModel.kokyakuZip != null">
                            〒{{reqModel.kokyakuZip}}
                            <p>{{reqModel.kokyakuAddr1}}
                                <br>
                                {{reqModel.kokyakuAddr2}}
                                <br>
                                {{reqModel.kokyakuAddr3}}
                            </p>
                        </td>
                    </tr>
                    <tr v-if="showBetuOrder">
                        <!-- 注文者電話番号 -->
                        <th>{{dataInit.dairiNm}}{{$t("common.labels.phoneNumber")}}</th>
                        <td>
                            {{reqModel.kokyakuTel}}
                        </td>
                    </tr>
                </table>
            </div>

            <div class="sh030-body-msg" v-if="reqModel.yoyakuKbn=='2'||reqModel.yoyakuKbn=='3'||reqModel.yoyakuKbn=='4'">
                <p class="mb08">
                    <!-- ご注文した商品に、予約商品が含まれています。 -->
                    {{$t("sh030.labels.pre-orderItem")}} <br />
                    <!-- 下記の中から、ご希望の配送方法を選択してください。 -->
                    {{$t("sh030.labels.selectMethod")}}<br />
                    <!-- ※通常商品は、1回の発送となります。 -->
                    {{$t("sh030.labels.nomalProduct")}}<br />
                    <!-- 配送方法を分割した場合は、分割ごとにご注文メールが配信されます。 -->
                    {{$t("sh030.labels.deliveredEachSplit")}}
                </p>
                <label class="select_yoyaku" for="yoyaku_radiogroup_1" v-if="reqModel.yoyakuKbn=='2'||reqModel.yoyakuKbn=='3'">
                    <input type="radio" id="yoyaku_radiogroup_1" v-model="reqModel.radiogroup2" value="1" class="margin-left-10px" >
                    <b>
                        <!-- 出荷できる商品を出荷し、予約商品は全て揃ってから出荷する。(送料・手数料は2回分) -->
                        {{$t("sh030.labels.shipHandingTwice")}}
                    </b>
                </label>
                <label class="select_yoyaku" for="yoyaku_radiogroup_2" v-if="reqModel.yoyakuKbn=='3'||reqModel.yoyakuKbn=='4'">
                    <input type="radio" id="yoyaku_radiogroup_2" v-model="reqModel.radiogroup2" value="2" class="margin-left-10px"
                    >
                    <b>
                        <!-- 出荷できる商品から出荷する。(送料・手数料が出荷回数分となります。) -->
                        {{$t("sh030.labels.shipOfShipment")}}
                    </b>
                </label>
                <label class="select_yoyaku mb08" for="yoyaku_radiogroup_3">
                    <input type="radio" id="yoyaku_radiogroup_3" v-model="reqModel.radiogroup2" value="3" class="margin-left-10px" >
                    <b>
                        <!-- 全ての商品が揃ってから出荷する。 -->
                        {{$t("sh030.labels.shipAfter")}}
                    </b>
                </label>
            </div>

            <!--ゲストの場合 -->
            <template v-if="dataInit.kokyakuNo == 999999999">
                <p class="mb32">
                    <!--項目内の[必須] の箇所は入力必須項目です。-->
                    <span v-html="descriptionInfo[1]"></span>
                </p>
                <p class="caution mb32">
                    <!-- 機種依存文字は入力できません。 -->
                    <span v-html="descriptionInfo[2]"></span>
                    <!-- ※Yahoo!メールを使用している方は、大切なお知らせが届くように「shop@demo.co.jp」を、なりすましメール拒否設定の救済リストに追加してください。 -->
                </p>
                <div class="sh030-body-guest-area">
                    <table class="sh030-body-order-tbl-person sh030-body-order-tbl-mb32">
                        <tr>
                            <!-- お名前※ -->
                            <th class="required">{{$t("sh030.labels.name")}}</th>
                            <td>
                                <div class="sh030-form-column">
                                    <!-- 姓 -->
                                    <template v-if="dataInit.name2Flg == 1">
                                        <label class="sh030-form-column-num02">{{$t("pt330.labels.surname")}}</label>
                                    </template>
                                    <template v-else>
                                        <label class="sh030-form-column-num02">{{$t("pt330.labels.name1")}}</label>
                                    </template>
                                    <input-check type="text" id="kokyakuNm1" name="kokyakuNm1" v-model="reqModel.kokyakuNm1" size="20" maxlength="50" class="multi"/>
                                    <!-- 名 -->
                                    <template v-if="dataInit.name2Flg == 1">
                                        <label class="sh030-form-column-num02">{{$t("pt330.labels.name2")}}</label>
                                        <input-check type="text" id="kokyakuNm2" name="kokyakuNm2" v-model="reqModel.kokyakuNm2" size="20" maxlength="50" class="multi"/>
                                    </template>
                                </div>
                                <div v-html="descriptionInfo[3]"></div>
                            </td>
                        </tr>
                        <tr>
                            <!-- フリガナ -->
                            <th v-if="dataInit.kanaHissuFlg == 1" class="required">{{$t("sh030.labels.name")}}（{{$t("sh030.labels.nameKana")}}）</th>
                            <th v-else class="optional">{{$t("sh030.labels.name")}}（{{$t("sh030.labels.nameKana")}}）</th>
                            <td>
                                <div class="sh030-form-column">
                                    <!-- 姓 -->
                                    <template v-if="dataInit.name2Flg == 1">
                                        <label class="sh030-form-column-num02">{{$t("pt330.labels.surname")}}</label>
                                    </template>
                                    <template v-else>
                                        <label class="sh030-form-column-num02">{{$t("pt330.labels.name1")}}</label>
                                    </template>
                                    <input-check type="text" id="kokyakuKana1" name="kokyakuKana1" v-model="reqModel.kokyakuKana1" size="20" maxlength="50" class="multi"/>
                                    <!-- 名 -->
                                    <template v-if="dataInit.name2Flg == 1">
                                        <label class="sh030-form-column-num02">{{$t("pt330.labels.name2")}}</label>
                                        <input-check type="text" id="kokyakuKana2" name="kokyakuKana2" v-model="reqModel.kokyakuKana2" size="20" maxlength="50" class="multi"/>
                                    </template>
                                </div>
                                <div v-html="descriptionInfo[4]"></div>
                            </td>
                        </tr>
                        <tr>
                            <th class="required">
                                <!-- 郵便番号 -->
                                {{$t("common.labels.postalCode")}}
                            </th>
                            <td ontouchstart="">
                                <input-check type="text" id="kokyakuZip" name="kokyakuZip" v-model="reqModel.kokyakuZip" size="13" maxlength="8" class="zip form-control-sm" @on-input-change="onGuestZipChange(); setAddr('kokyaku')"/>
                                <button class="zip-btn"  @click="setAddr('kokyaku')"> {{$t("common.labels.addressSearch")}} </button>
                                <div v-html="descriptionInfo[5]"></div>
                            </td>
                        </tr>
                        <!-- 都道府県CD -->
                        <template v-if="dataInit.kenPulldownDispFlg == 1">
                            <tr>
                                <th class="required">
                                    <!-- 都道府県 -->
                                    {{$t("sh030.labels.prefectures")}}
                                </th>
                                <td>
                                    <select v-model="reqModel.kokyakuKenCd" id="kokyakuKenCd">
                                        <option v-for="ken in dataInit.kenList" :key="ken.KEY" :value="ken.KEY" :selected="ken.KEY == reqModel.kokyakuKenCd">{{ken.VALUE}}</option>
                                    </select>
                                    <br>
                                    <div v-html="descriptionInfo[6]"></div>
                                </td>
                            </tr>
                        </template>
                        <template v-else>
                            <input type="hidden" v-model="reqModel.kokyakuKenCd" />
                        </template>
                        <tr>
                            <th class="required">
                                <!-- 住所（市区郡町村） -->
                                {{$t("sh030.labels.cityAndCounty")}}
                            </th>
                            <td>
                                <input-check id="kokyakuAddr1" type="text" name="kokyakuAddr1" size="50" v-model="reqModel.kokyakuAddr1" maxlength="100"/>
                                <br/>
                                 <template v-if="dataInit.kenPulldownDispFlg == 1">
                                    <div v-html="descriptionInfo[7]"></div>
                                </template>
                                <template v-else>
                                    <div v-html="descriptionInfo[8]"></div>
                                </template>
                            </td>
                        </tr>
                        <tr v-if="dataInit.addr2Flg == 1">
                            <!-- 住所（番地以下） -->
                            <th v-if="dataInit.addr2HissuFlg == 1" class="required">{{$t("sh030.labels.streetAddress")}}</th>
                            <th v-else class="optional">{{$t("sh030.labels.streetAddress")}}</th>
                            <td>
                                <input-check id="kokyakuAddr2" type="text" name="kokyakuAddr2" size="50" v-model="reqModel.kokyakuAddr2" maxlength="100"/>
                                <br/>
                                <div v-html="descriptionInfo[9]"></div>
                            </td>
                        </tr>
                        <tr v-if="dataInit.addr3Flg == 1">
                            <!-- 住所（マンション名・会社名等） -->
                            <th v-if="dataInit.addr3HissuFlg == 1" class="required">{{$t("sh030.labels.apartmentName")}}</th>
                            <th class="optional">{{$t("sh030.labels.apartmentName")}}</th>
                            <td>
                                <input-check id="kokyakuAddr3" type="text" name="kokyakuAddr3" size="50" v-model="reqModel.kokyakuAddr3" MaxLength="100"/>
                                <br/> 
                                <div v-html="descriptionInfo[10]"></div>
                            </td>
                        </tr>

                        <tr>
                            <th class="required" rowspan="2">
                                <!-- メールアドレス -->
                                {{$t("sh060.labels.mailAddress")}}
                            </th>
                            <td>
                                <input-check type="text" id="kokyakuMail1" name="kokyakuMail1" v-model="reqModel.kokyakuMail1" size="60" maxlength="100" class="mail"/>
                                <br>
                                <div v-html="descriptionInfo[11]"></div>
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <input-check type="text" id="kokyakuMail2_confirm" name="kokyakuMail2_confirm" v-model="reqModel.kokyakuMail2_confirm" size="60" maxlength="100" class="mail"/>
                                <br>
                                <div v-html="descriptionInfo[12]"></div>
                            </td>
                        </tr>

                        <tr>
                            <th class="required">
                                <!-- 電話番号※ -->
                                {{$t("sh030.labels.phoneNumber※")}}
                            </th>
                            <td>
                                <input-check type="text" id="kokyakuTel" name="kokyakuTel" v-model="reqModel.kokyakuTel" size="20" maxlength="15" class="tel"/>
                                <div v-html="descriptionInfo[13]"></div>
                            </td>
                        </tr>
                        <tr>
                            <th class="optional">
                                <label for="form-orderBirthday">
                                    <!-- 生年月日 -->
                                    {{$t("common.labels.birthday")}}
                                </label>
                            </th>
                            <td>
                                <input-check type="text" id="birthDayYYYY" class="birthYearInput numcode" name="birthDay_YYYY" maxlength="4" size="7" v-model="reqModel.birthDayYYYY"/>
                                <span class="birthYear">{{$t('common.labels.year')}}</span>
                                <select v-model="reqModel.birthDayMM" name="birthDay_MM" class="birthMonthSelect">
                                    <option></option>
                                    <template v-for="mm in 12" >
                                        <option v-if="mm < 10" :key="mm" :value="'0'+mm">{{'0'+mm}}</option>
                                        <option v-else :key="mm" :value="mm">{{mm}}</option>
                                    </template>
                                </select>
                                <span class="birthMonth">{{$t('common.labels.month')}}</span>
                                <select v-model="reqModel.birthDayDD" name="birthDay_DD" class="birthDaySelect">
                                    <option></option>
                                    <template v-for="dd in 31" >
                                        <option v-if="dd < 10" :key="dd" :value="'0'+dd">{{'0'+dd}}</option>
                                        <option v-else :key="dd" :value="dd">{{dd}}</option>
                                    </template>
                                </select>
                                <span class="birthDay">{{$t('common.labels.day')}}</span>

                                <div v-html="descriptionInfo[14]"></div>
                            </td>
                        </tr>
                        <tr>
                            <th class="optional">
                                <label for="form-orderSex">
                                    <!-- 性別 -->
                                    {{$t("common.labels.sex")}}
                                </label>
                            </th>
                            <td>
                                <select id="kokyakuSexKbn" name="kokyakuSexKbn" v-model="reqModel.kokyakuSexKbn">
                                    <option v-for="sexKbn in dataInit.sexKbnList" :key="sexKbn.KEY" :value="sexKbn.KEY">{{sexKbn.VALUE}}</option>
                                </select>
                                <br>
                                <span v-html="descriptionInfo[15]"></span>
                            </td>
                        </tr>
                    </table>
                    <!-- 届先情報-->
                    <div class="text-left" >
                        <h4>{{$t("sh030.labels.tdkInformation")}}</h4>
                    </div>
                    <template v-if="dataInit.tdkOtherFlg == 1 || dataInit.tdkYaOfficeflg == 1">
                        <p class="mb32">
                            <!--項目内の[必須] の箇所は入力必須項目です。-->
                            <span v-html="descriptionInfo[1]"></span>
                        </p>
                        <p class="caution mb32">
                            <!-- 機種依存文字は入力できません。 -->
                            <span v-html="descriptionInfo[2]"></span>
                            <!-- ※Yahoo!メールを使用している方は、大切なお知らせが届くように「shop@demo.co.jp」を、なりすましメール拒否設定の救済リストに追加してください。 -->
                        </p>
                    </template>
                    <label for="radiogroup_1" class="select_add">
                        <input type="radio" id="radiogroup_1" name="radioGroup" value="1" v-model="reqModel.radioGroup" @change="radioClick" class="margin-left-10px">
                        <!-- 注文者住所に送る -->
                        <b> {{$t("sh030.labels.sendOrdererAddress")}}</b>
                    </label>
                    <template v-if="siteFlg == '0' && dataInit.tdkOtherFlg == 1">
                        <label for="radiogroup_3" class="select_add">
                            <input type="radio" id="radiogroup_3" name="radioGroup" value="2" v-model="reqModel.radioGroup" @change="radioClick"  class="margin-left-10px">
                            <!-- 別のお届け先に送る -->
                            <b> {{$t("sh030.labels.sendToAnotherAddressee")}}</b>
                        </label>
                    </template>
                    <template v-if="siteFlg == '0' && dataInit.tdkYaOfficeflg == 1">
                        <label for="radiogroup_4" class="select_add">
                            <input type="radio" id="radiogroup_4" name="radioGroup" value="4" v-model="reqModel.radioGroup" @change="radioClick"  class="margin-left-10px">
                            <!-- ヤマト 営業所止置きサービスを利用する -->
                            <b> {{$t("sh030.labels.sendYaOfficeAddresse")}}</b>
                        </label>
                    </template>
                    <br>
                    <table>
                        <tbody>
                            <tr align="center">
                                <td align="center">
                                    <span class="es_strAttn">
                                        <span v-html="descriptionInfo[16]"></span>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                        
                    <br>
                    <template v-if="dataInit.uketori=='1'">
                        <div id="hide_table_2"   v-if="reqModel.radioGroup==3" >
                            <span class="input-span-uketoriMsg-css" v-html="dataInit.uketoriMsg"></span>
                            <div class="div-ukeba-css">
                                <!-- 受取場所選択 -->
                                <button @click="callMapInfo"  class="zip-btn btn-width-150px-css" type="button" >
                                    {{$t("sh030.buttons.receivingPlaceSelection")}}
                                </button>
                                <!-- 受取場所クリア -->
                                <button @click="clearOrderAddr" class="zip-btn btn-width-150px-css" type="button" >
                                    {{$t("sh030.buttons.receivingPlaceClear")}}
                                </button>
                            </div>
                            <table class="personal mb32 mt10">
                                <tr>
                                    <th>
                                        <!-- 受取場所 -->
                                        {{$t("sh060.labels.receivingPlace")}}
                                    </th>
                                    <td>
                                        <div v-if="mapInfoChangeTdkFlag">
                                            {{dataInit.location}}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <!-- 受取場所住所 -->
                                        {{$t("sh060.labels.receivingPlaceAddress")}}
                                        
                                    </th>
                                    <td>
                                        〒
                                        <span v-if="mapInfoChangeTdkFlag">{{reqModel.orderAddrZip}}
                                                <br>
                                            {{reqModel.orderAddrAddr1}}
                                        </span>
                                        <div v-else>
                                            <div id="clear_2_2">&nbsp;</div>
                                            <div id="clear_2_2">&nbsp;</div>
                                            <div id="clear_2_2">&nbsp;</div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    
                                    <th class="required">
                                        <!-- お名前※ -->
                                        <span>{{$t("sh030.labels.name")}}</span>
                                    </th>
                                    <td>
                                        <div class="form-column">
                                            <!-- 姓 -->
                                            <label class="sh030-form-column-num02">{{$t("pt330.labels.surname")}}</label>
                                            <input-check type="text" id="orderAddrNm1" name="orderAddrNm1"
                                                size="20" maxlength="50" class="multi" v-model="reqModel.orderAddrNm1"/>
                                            <!-- 名 -->
                                            <label class="sh030-form-column-num02">{{$t("pt330.labels.name2")}}</label>
                                            <input-check type="text" id="orderAddrNm2" name="orderAddrNm2"
                                                size="20" maxlength="50" class="multi" v-model="reqModel.orderAddrNm2"/>
                                        </div>
                                        <span class="ex">{{$t("sh030.labels.surnameEx")}}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <!-- フリガナ -->
                                    <th v-if="dataInit.kanaHissuFlg == 1" class="required">{{$t("sh030.labels.name")}}
                                        <span id="nameKana_lbl">{{$t("sh030.labels.nameKana")}}</span>）
                                    </th>
                                    <th v-else class="optional">{{$t("sh030.labels.name")}} 
                                    （<span id="nameKana_lbl">{{$t("sh030.labels.nameKana")}}</span>）
                                    </th>
                                    <td>
                                        <div class="form-column">
                                            <!-- 姓 -->
                                            <label class="sh030-form-column-num02">{{$t("pt330.labels.surname")}}</label>
                                            <input-check type="text" id="orderAddrKanaNm1" name="orderAddrKanaNm1" v-model="reqModel.orderAddrKanaNm1" 
                                                size="20" maxlength="50" class="multi"/>
                                            <!-- 名 -->
                                            <label class="sh030-form-column-num02">{{$t("pt330.labels.surname")}}</label>
                                            <input-check type="text" id="orderAddrKanaNm2" name="orderAddrKanaNm2" v-model="reqModel.orderAddrKanaNm2"
                                                size="20" maxlength="50" class="multi"/>
                                        </div>
                                        <span class="ex">{{$t("sh030.labels.name2Ex")}}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th class="required">
                                        <!-- 電話番号※ -->
                                        {{$t("sh030.labels.phoneNumber※")}}
                                    </th>
                                    <td>
                                        <input-check type="text" id="orderAddrTel" name="orderAddrTel" v-model="reqModel.orderAddrTel" size="20" maxlength="15" class="tel"/>
                                        <span v-html="descriptionInfo[13]"></span>
                                    </td>
                                </tr>
                                <tr>
                                    <th class="required">
                                        <!-- 届先メールアドレス -->
                                        <span>{{$t("sh030.labels.deliveryMailAddress")}}</span>
                                    </th>
                                    <td>
                                        <input-check type="text" id="orderAddrMail" name="orderAddrMail" v-model="reqModel.orderAddrMail" size="60" maxlength="100" class="mail"/>
                                        <span v-html="descriptionInfo[12]"></span>
                                    </td>
                                </tr>
                            </table>
                            <!-- こちらの住所は今回のご注文でのみ有効です。 -->
                            <p><b class="input-p-desc-css">※ {{$t("sh030.labels.addressValidOnlyOrder")}}</b></p>
                        </div>
                    </template>    
                </div>
            </template>
            <!--ログイン済顧客の場合-->
            <div class="sh030-body-kaiin-area" v-if="dataInit.kokyakuNo != 999999999">
                <!-- お届先情報-->
                <div class="subTitle" >
                    <h4>{{$t("sh030.labels.tdkInformation")}}</h4>
                </div>
                <!--オプション50521 別の届け先利用の場合-->
                <template v-if="dataInit.tdkOtherFlg == 1 || dataInit.tdkYaOfficeflg == 1">
                    <p class="mb32">
                        <!--項目内の[必須] の箇所は入力必須項目です。-->
                        <span v-html="descriptionInfo[1]"></span>
                    </p>
                    <p class="caution mb32">
                        <!-- 機種依存文字は入力できません。 -->
                        <span v-html="descriptionInfo[2]"></span>
                        <!-- ※Yahoo!メールを使用している方は、大切なお知らせが届くように「shop@demo.co.jp」を、なりすましメール拒否設定の救済リストに追加してください。 -->
                    </p>
                </template>
                <label for="radiogroup_1" class="select_add" v-if="dataInit.tdkCount == 1 && dataInit.catalogFlg != 1 && (reqModel.kessaiCd != Constants.KESSAI_AMAZONPAY || (reqModel.kessaiCd == Constants.KESSAI_AMAZONPAY && !reqModel.amazonCheckoutSessionId))">
                    <input type="radio" id="radiogroup_1" name="radioGroup" value="1" v-model="reqModel.radioGroup" @change="radioClick" class="margin-left-10px">
                    <!-- 注文者住所に送る -->
                    <b> {{$t("sh030.labels.sendOrdererAddress")}}</b>
                </label>
                <template v-if="dataInit.tdkOtherFlg == 1 && dataInit.tdkCount == 1 && dataInit.catalogFlg != 1 && dataInit.onlyStorePickupFlg != 1 && (reqModel.kessaiCd != Constants.KESSAI_AMAZONPAY || (reqModel.kessaiCd == Constants.KESSAI_AMAZONPAY && !reqModel.amazonCheckoutSessionId))">
                    <label for="radiogroup_3" class="select_add">
                        <input type="radio" id="radiogroup_3" name="radioGroup" value="2" v-model="reqModel.radioGroup" @change="radioClick"  class="margin-left-10px">
                        <!-- 別のお届け先に送る -->
                        <b> {{$t("sh030.labels.sendToAnotherAddressee")}}</b>
                    </label>
                </template>
                <template v-if="siteFlg == '0' && dataInit.tdkYaOfficeflg == 1 && dataInit.tdkCount == 1 && dataInit.catalogFlg != 1  && reqModel.kessaiCd != Constants.KESSAI_AMAZONPAY">
                    <label for="radiogroup_4" class="select_add">
                        <input type="radio" id="radiogroup_4" name="radioGroup" value="4" v-model="reqModel.radioGroup" @change="radioClick"  class="margin-left-10px">
                        <!-- ヤマト 営業所止置きサービスを利用する -->
                        <b> {{$t("sh030.labels.sendYaOfficeAddresse")}}</b>
                    </label>
                </template>
                <label v-if="dataInit.csmInfoOption == 1 && dataInit.ecCsmInfoOption == 1" for="okuriNushiCheckBox" class="select_add">
                    <input type="checkbox" id="okuriNushiCheckBox" true-value="1" false-value="0" v-model="reqModel.okuriNushiCheckBox" class="margin-left-10px">
                    <!-- 送主を入力する -->
                    <b>{{$t("sh030.labels.okuriNushiOrder")}}</b>
                </label>
                <label v-if="dataInit.seikyudoukonOption == 1 && dataInit.siteSeikyudoukonOption == 1  && dataInit.tdkCount == 1 && dataInit.catalogFlg != 1"  for="seikyuDoukonFlg" class="select_add">
                    <input type="checkbox" id="seikyuDoukonFlg" true-value="1" false-value="0" v-model="reqModel.seikyuDoukonFlg" class="margin-left-10px">
                    <b>{{$t("sh030.labels.seikyuDoukonFlg")}}</b>
                </label>
                <br>
                <table class="sh030-body-order-tbl-person sh030-body-order-tbl-mb32" id="hide_table_1" v-if="reqModel.radioGroup==1 && dataInit.catalogFlg != 1">
                    <tr>
                        <th>
                            <!-- お届け先名 -->
                            {{$t("sh060.labels.destinationname")}}
                        </th>
                        <td>
                            {{reqModel.tdkNm1ForMultTdk}} {{reqModel.tdkNm2ForMultTdk}} {{reqModel.tdkNm3ForMultTdk}}
                        </td>
                    </tr>
                    <tr>
                        <th>
                            <!-- ご住所 -->
                            {{$t("sh060.labels.address")}}
                        </th>
                        <td>
                            〒{{reqModel.tdkZipCdForMultTdk}}
                            <p>{{reqModel.tdkAddr1ForMultTdk}}
                                <br>
                                {{reqModel.tdkAddr2ForMultTdk}}
                                <br>
                                {{reqModel.tdkAddr3ForMultTdk}}
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            <!-- 電話番号 -->
                            {{$t("common.labels.phoneNumber")}}
                        </th>
                        <td>
                            {{reqModel.kokyakuTel}}
                        </td>
                    </tr>
                    <!-- else{//BtoBの場合} -->
                </table>
                <template v-if="dataInit.uketori == '1'">
                    <div id="hide_table_2" v-if="reqModel.radioGroup==3" >
                        <span class="input-span-uketoriMsg-css" v-html="dataInit.uketoriMsg"></span>
                        <div class="div-ukeba-css" >
                            <!-- 受取場所選択 -->
                            <button @click="callMapInfo"  class="zip-btn btn-width-150px-css" type="button">
                                {{$t("sh030.buttons.receivingPlaceSelection")}}
                            </button>
                            <!-- 受取場所クリア -->
                            <button @click="clearOrderAddr" class="zip-btn btn-width-150px-css" type="button">
                                {{$t("sh030.buttons.receivingPlaceClear")}}
                            </button>
                        </div>
                        <table  class="sh030-body-order-tbl-person mb64">
                            <tr>
                                <th>
                                    <!-- 受取場所 -->
                                    {{$t("sh060.labels.receivingPlace")}}
                                </th>
                                <td>
                                    <div v-if="mapInfoChangeTdkFlag">
                                        {{reqModel.location}}
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <!-- 受取場所住所 -->
                                    {{$t("sh060.labels.receivingPlaceAddress")}}
                                    
                                </th>
                                <td>
                                    〒
                                    <span v-if="mapInfoChangeTdkFlag">{{reqModel.orderAddrZip}}
                                            <br>
                                        {{reqModel.orderAddrAddr1}}
                                    </span>
                                    <div v-else>
                                        <div id="clear_2_2">&nbsp;</div>
                                        <div id="clear_2_2">&nbsp;</div>
                                        <div id="clear_2_2">&nbsp;</div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="required">
                                    <!-- お名前※ -->
                                    {{$t("sh030.labels.name")}}
                                </th>
                                <td>
                                    <div class="sh030-form-column">
                                        <!-- 姓 -->
                                        <label class="sh030-form-column-num02">{{$t("pt330.labels.surname")}}</label>
                                        <input-check type="text" id="orderAddrNm1" name="orderAddrNm1"
                                            size="20" maxlength="50" class="multi" v-model="reqModel.orderAddrNm1"/>
                                        <!-- 名 -->
                                        <label class="sh030-form-column-num02">{{$t("pt330.labels.name2")}}</label>
                                        <input-check type="text" id="orderAddrNm2" name="orderAddrNm2"
                                            size="20" maxlength="50" class="multi" v-model="reqModel.orderAddrNm2"/>
                                    </div>
                                    <span class="ex">{{$t("sh030.labels.surnameEx")}}</span>
                                </td>
                            </tr>
                            <tr>
                                <th class="optional">
                                    <!-- フリガナ -->
                                    {{$t("sh030.labels.name")}}（{{$t("sh030.labels.nameKana")}}）
                                </th>
                                <td>
                                    <div class="sh030-form-column">
                                        <!-- 姓 -->
                                        <label class="sh030-form-column-num02">{{$t("pt330.labels.surname")}}</label>
                                        <input-check type="text" id="orderAddrKanaNm1" name="orderAddrKanaNm1" v-model="reqModel.orderAddrKanaNm1"
                                        size="20" maxlength="50" class="multi"/>
                                        <!-- 名 -->
                                        <label class="sh030-form-column-num02">{{$t("pt330.labels.name2")}}</label>
                                        <input-check type="text" id="orderAddrKanaNm2" name="orderAddrKanaNm2" v-model="reqModel.orderAddrKanaNm2" 
                                        size="20" maxlength="50" class="multi"/>
                                    </div>
                                    <span class="ex">{{$t("sh030.labels.name2Ex")}}</span>
                                </td>
                            </tr>
                            <tr>
                                <th class="required">
                                    <!-- 電話番号※ -->
                                    {{$t("sh030.labels.phoneNumber※")}}
                                </th>
                                <td>
                                    <input-check type="text" id="orderAddrTel" name="orderAddrTel" v-model="reqModel.orderAddrTel" size="20" maxlength="15" class="multi"/>
                                    <span v-html="descriptionInfo[25]"></span>
                                </td>
                            </tr>
                            <tr>
                                <th class="required">
                                    <!-- 届先メールアドレス -->
                                    {{$t("sh030.labels.deliveryMailAddress")}}
                                </th>
                                <td>
                                    <input-check type="text" id="orderAddrMail" name="orderAddrMail" v-model="reqModel.orderAddrMail" size="60" maxlength="100" class="multi"/>
                                    <span v-html="descriptionInfo[26]"></span>
                                </td>
                            </tr>
                        </table>
                        <!-- こちらの住所は今回のご注文でのみ有効です。 -->
                        <p class="input-p-desc-css">※ {{$t('sh030.labels.addressValidOnlyOrder')}}</p> 
                    </div>
                </template>
            </div>
            <!--別の届け先 -->
            <div class="sh030-body-betu-tdk-area" id="hide_table_3" v-if="reqModel.radioGroup==2 && dataInit.tdkCount == 1">
                <table  class="sh030-body-order-tbl-person" >
                    <!--送り主（BtoC） -->
                    <template v-if="dataInit.siteFlg != 1">
                        <tr>
                            <th class="required">
                                <!-- お名前※ -->
                                {{$t("sh030.labels.name")}}
                            </th>
                            <td>
                                <div class="sh030-form-column left">
                                    <input type="hidden" v-model="reqModel.tdkNo">
                                    <!-- 姓 -->
                                    <template v-if="dataInit.name2Flg == 1">
                                        <label class="sh030-form-column-num02">{{$t("pt330.labels.surname")}}</label>
                                    </template>
                                    <template v-else>
                                        <label class="sh030-form-column-num02">{{$t("pt330.labels.name1")}}</label>
                                    </template>
                                    <!--配送先名を自分宛にするフラグを利用しない場合-->
                                    <template v-if="dataInit.tdkMyAddrFlg == 0">
                                        <input-check type="text" id="tdkNm1" name="tdkNm1"
                                                v-model="reqModel.tdkNm1" size="20"
                                                maxlength="50" class="multi"/>
                                    </template>
                                    <!--配送先名を自分宛にするフラグを利用する場合-->
                                    <template v-else>
                                        <input-check type="text" id="tdkNm1" name="tdkNm1"
                                                disabled 
                                                v-model="reqModel.tdkNm1" size="20" 
                                                maxlength="50" class="multi input-p-okuriNushiKana2-css"/>
                                    </template>
                                    <!-- 名2 -->
                                    <template v-if="dataInit.name2Flg == 1">
                                        <label class="sh030-form-column-num02">{{$t("pt330.labels.name2")}}</label>
                                        <!--配送先名を自分宛にするフラグを利用しない場合-->
                                        <template v-if="dataInit.tdkMyAddrFlg == 0">
                                            <input-check type="text" id="tdkNm2" name="tdkNm2"
                                                        v-model="reqModel.tdkNm2" size="20"
                                                        maxlength="50" class="multi"/>
                                        </template>
                                        <!--配送先名を自分宛にするフラグを利用する場合-->
                                        <template v-else>
                                            <input-check type="text" id="tdkNm2" name="tdkNm2"
                                                        disabled 
                                                        v-model="reqModel.tdkNm2" size="20"
                                                        maxlength="50" class="multi input-p-okuriNushiKana2-css"/>
                                        </template>
                                    </template>
                                    <template v-if="dataInit.tdkKeisyouPullDownFlg == 1">
                                        <select v-model="reqModel.tdkHyoujiKeisyo" id="tdkHyoujiKeisyo">
                                            <option v-for="tdkKeisyou in dataInit.tdkHyoujiKeisyoList" :key="tdkKeisyou.KEY" :value="tdkKeisyou.KEY" :selected="tdkKeisyou.KEY == reqModel.tdkHyoujiKeisyo">{{tdkKeisyou.VALUE}}</option>
                                        </select>
                                    </template>
                                </div>
                                <!-- 届先を検索-->
                                <button class="tdk-btn" type="button" v-if="dataInit.catalogOrderOpt != 1 && dataInit.kokyakuNo != 999999999"
                                @click="searchTdkList()">{{$t("sh030.labels.serAddressee")}}</button>
                                <br />
                                <div v-html="descriptionInfo[17]"></div>
                            </td>
                        </tr>
                        <tr>
                            <!-- フリガナ -->
                            <th v-if="dataInit.kanaHissuFlg == 1" class="required">{{$t("sh030.labels.nameKana")}}</th>
                            <th v-else class="optional">{{$t("sh030.labels.nameKana")}}</th>
                            <td>
                                <div class="sh030-form-column">
                                    <!-- 姓 -->
                                    <template v-if="dataInit.name2Flg == 1">
                                        <label class="sh030-form-column-num02">{{$t("pt330.labels.surname")}}</label>
                                    </template>
                                    <template v-else>
                                        <label class="sh030-form-column-num02">{{$t("pt330.labels.name1")}}</label>
                                    </template>
                                    <!--配送先名を自分宛にするフラグを利用しない場合-->
                                    <template v-if="dataInit.tdkMyAddrFlg == 0">
                                        <input-check type="text" id="tdkKana1" name="tdkKana1"
                                                v-model="reqModel.tdkKana1" size="20"
                                                maxlength="50" class="multi"/>
                                    </template>
                                    <!--配送先名を自分宛にするフラグを利用する場合-->
                                    <template v-else>
                                        <input-check type="text" id="tdkKana1" name="tdkKana1"
                                                disabled
                                                v-model="reqModel.tdkKana1" size="20"
                                                maxlength="50" class="multi input-p-okuriNushiKana2-css"/>
                                    </template>
                                    <!-- 名 -->
                                    <template v-if="dataInit.name2Flg == 1">
                                        <label class="sh030-form-column-num02">{{$t("pt330.labels.name2")}}</label>
                                        <!--配送先名を自分宛にするフラグを利用しない場合-->
                                        <template v-if="dataInit.tdkMyAddrFlg == 0">
                                            <input-check type="text" id="tdkKana2" name="tdkKana2"
                                                    v-model="reqModel.tdkKana2" size="20"
                                                    maxlength="50" class="multi"/>
                                        </template>
                                        <!--配送先名を自分宛にするフラグを利用する場合-->
                                        <template v-else>
                                            <input-check type="text" id="tdkKana2" name="tdkKana2"
                                                    disabled 
                                                    v-model="reqModel.tdkKana2" size="20"
                                                    maxlength="50" class="multi input-p-okuriNushiKana2-css"/>
                                        </template>
                                    </template>
                                    <br/>
                                </div>
                                <div v-html="descriptionInfo[18]"></div>
                            </td>
                        </tr>
                        <tr>
                            <th class="required">
                                <!-- 郵便番号 -->
                                {{$t("common.labels.postalCode")}}
                            </th>
                            <td class="zip-add" ontouchstart="">
                                <input-check type="text" id="tdkZipCd" name="tdkZipCd" v-model="reqModel.tdkZipCd" @on-input-change="onBlurZipCd(); setAddr('tdk')" size="13" maxlength="8" class="zip form-control-sm"/>
                                <!-- 住所自動入力 -->
                                <button class="zip-btn"  @click="setAddr('tdk')"> {{$t("common.labels.addressSearch")}}</button>
                                <div v-html="descriptionInfo[19]"></div>
                            </td>
                        </tr>
                        <!-- 都道府県 -->
                        <template v-if="dataInit.kenPulldownDispFlg == 1">
                            <tr>
                                <th class="required">
                                    <!-- 都道府県 -->
                                    {{$t("sh030.labels.prefectures")}}
                                </th>
                                <td>
                                    <select v-model="reqModel.tdkKenCd" id="tdkKenCd">
                                        <option v-for="ken in dataInit.kenList" :key="ken.KEY" :value="ken.KEY" :selected="ken.KEY == reqModel.tdkKenCd">{{ken.VALUE}}</option>
                                    </select>
                                    <br>
                                    <div v-html="descriptionInfo[20]"></div>
                                </td>
                            </tr>
                        </template>
                        <template v-else>
                            <input type="hidden" v-model="reqModel.tdkKenCd" />
                        </template>
                        <tr>
                            <!-- 住所（市区郡町村） -->
                            <th class="required">{{$t("sh030.labels.cityAndCounty")}}</th>
                            <td>
                                <input-check id="tdkAddr1" type="text" name="tdkAddr1" size="50" v-model="reqModel.tdkAddr1" maxlength="100"/>
                                <br/>
                                <template v-if="dataInit.kenPulldownDispFlg == 1">
                                    <div v-html="descriptionInfo[21]"></div>
                                </template>
                                <template v-else>
                                    <div v-html="descriptionInfo[22]"></div>
                                </template>
                            </td>
                        </tr>
                        <!-- 住所（番地以下） -->
                        <tr v-if="dataInit.addr2Flg == 1">
                            <th v-if="dataInit.addr2HissuFlg == 1" class="required">{{$t("sh030.labels.streetAddress")}}</th>
                            <th v-else class="optional">{{$t("sh030.labels.streetAddress")}}</th>
                            <td>
                                <input-check id="tdkAddr2" type="text" name="tdkAddr2" size="50" v-model="reqModel.tdkAddr2" maxlength="100"/><br/>
                                <div v-html="descriptionInfo[23]"></div>
                            </td>
                        </tr>
                        <!-- 住所（マンション名・会社名等） -->
                        <tr v-if="dataInit.addr3Flg == 1">
                            <th v-if="dataInit.addr3HissuFlg == 1" class="required">{{$t("sh030.labels.apartmentName")}}</th>
                            <th v-else class="optional">{{$t("sh030.labels.apartmentName")}}</th>
                            <td>
                                <input-check id="tdkAddr3" type="text" name="tdkAddr3" size="50" v-model="reqModel.tdkAddr3" maxLength="100"/><br/>
                                <div v-html="descriptionInfo[24]"></div>
                            </td>
                        </tr>
                        <tr>
                            <th class="required">
                                <!-- 電話番号※ -->
                                {{$t("sh030.labels.phoneNumber※")}}
                            </th>
                            <td>
                                <input-check type="text" id="tdkTelNo" name="tdkTelNo" v-model="reqModel.tdkTelNo" size="20" maxlength="15" class="tel"/>
                                <br>
                                <div v-html="descriptionInfo[25]"></div>
                            </td>
                        </tr>
                        <tr>
                            <!-- 届先メールアドレス -->
                            <th v-if="dataInit.mailAddrHissuFlg == 1" class="required">{{$t("sh030.labels.deliveryMailAddress")}}</th>
                            <th v-else class="optional">{{$t("sh030.labels.deliveryMailAddress")}}</th>
                            <td>
                                <input-check type="text" id="tdkMail1" name="tdkMail1" v-model="reqModel.tdkMail1" size="60" maxlength="100" class="mail"/>
                                <div v-html="descriptionInfo[26]"></div>
                            </td>
                        </tr>
                    </template>
                    <!--送り主（BtoB） -->
                    <template v-if="dataInit.siteFlg == 1">
                        <tr>
                            <th class="required">
                                {{$t("sh030.labels.kaisyame")}}
                            </th>
                            <td>
                                <div class="sh030-form-column left">
                                    <input type="hidden" v-model="reqModel.tdkNo">
                                    <input-check id="tdkNm1Comp" type="text" name="tdkNm1Comp" size="50" v-model="reqModel.tdkNm1Comp" maxlength="50"/>
                                </div>
                                <!-- 届先を検索-->
                                <button class="tdk-btn" type="button" v-if="dataInit.kokyakuNo != 999999999"
                                @click="searchTdkCompList()">{{$t("sh030.labels.serAddressee")}}</button>
                                <br />
                                <span v-html="descriptionInfo[17]"></span>
                            </td>
                        </tr>
                        <tr>
                            <!-- フリガナ -->
                            <th v-if="dataInit.kanaHissuFlg == 1" class="required">{{$t("sh030.labels.kaisyamekana")}}</th>
                            <th v-else class="optional">{{$t("sh030.labels.kaisyamekana")}}</th>
                            <td>
                                <div class="sh030-form-column">
                                    <input-check id="tdkKana1Comp" type="text" name="tdkKana1Comp" size="50" v-model="reqModel.tdkKana1Comp" maxlength="50"/>                                            
                                    <br/>
                                </div>
                                <span v-html="descriptionInfo[18]"></span>
                            </td>
                        </tr>
                        <tr>
                            <th class="optional">
                                {{$t("sh030.labels.bushoName")}}
                            </th>
                            <td>
                                <div class="sh030-form-column left">
                                    <input-check id="tdkNm2Comp" type="text" name="tdkNm2Comp" size="50" v-model="reqModel.tdkNm2Comp" maxlength="50"/>
                                </div>
                                <br />
                                <span v-html="descriptionInfo[43]"></span>
                            </td>
                        </tr>
                        <tr>
                            <th class="optional">
                                {{$t("sh030.labels.tantoshame")}}
                            </th>
                            <td>
                                <div class="sh030-form-column left">
                                    <input-check id="tdkNm3Comp" type="text" name="tdkNm3Comp" size="50" v-model="reqModel.tdkNm3Comp" maxlength="50"/>
                                </div>
                                <br />
                                <span v-html="descriptionInfo[44]"></span>
                            </td>
                        </tr>
                        <!-- 表示敬称 -->
                        <tr>
                            <th class="required">
                                <!-- 表示敬称 -->
                                {{$t("sh030.labels.hyoujiKeisyo")}}
                            </th>
                            <td>
                                <select v-model="reqModel.tdkHyoujiKeisyo" id="tdkHyoujiKeisyo">
                                    <option v-for="ken in dataInit.tdkHyoujiKeisyoList" :key="ken.KEY" :value="ken.KEY" :selected="ken.KEY == reqModel.tdkHyoujiKeisyo">{{ken.VALUE}}</option>
                                </select>
                                <br>
                            </td>
                        </tr>
                        <tr>
                            <th class="required">
                                <!-- 郵便番号 -->
                                {{$t("common.labels.postalCode")}}
                            </th>
                            <td class="zip-add" ontouchstart="">
                                <input-check type="text" id="tdkZipCdComp" name="tdkZipCdComp" v-model="reqModel.tdkZipCdComp" @on-input-change="onBlurZipCd(); setAddr('tdkComp')" size="13" maxlength="8" class="zip form-control-sm"/>
                                <!-- 住所自動入力 -->
                                <button class="zip-btn"  @click="setAddr('tdkComp')"> {{$t("common.labels.addressSearch")}}</button>
                                <div v-html="descriptionInfo[19]"></div>
                            </td>
                        </tr>
                        <!-- 都道府県 -->
                        <template v-if="dataInit.kenPulldownDispFlg == 1">
                            <tr>
                                <th class="required">
                                    <!-- 都道府県 -->
                                    {{$t("sh030.labels.prefectures")}}
                                </th>
                                <td>
                                    <select v-model="reqModel.tdkKenCdComp" id="tdkKenCdComp">
                                        <option v-for="ken in dataInit.kenList" :key="ken.KEY" :value="ken.KEY" :selected="ken.KEY == reqModel.tdkKenCd">{{ken.VALUE}}</option>
                                    </select>
                                    <br>
                                    <div v-html="descriptionInfo[20]"></div>
                                </td>
                            </tr>
                        </template>
                        <template v-else>
                            <input type="hidden" v-model="reqModel.tdkKenCdComp" />
                        </template>
                        <tr>
                            <!-- 住所（市区郡町村） -->
                            <th class="required">{{$t("sh030.labels.cityAndCounty")}}</th>
                            <td>
                                <input-check id="tdkAddr1Comp" type="text" name="tdkAddr1Comp" size="50" v-model="reqModel.tdkAddr1Comp" maxlength="100"/>
                                <br/>
                                <template v-if="dataInit.kenPulldownDispFlg == 1">
                                    <div v-html="descriptionInfo[21]"></div>
                                </template>
                                <template v-else>
                                    <div v-html="descriptionInfo[22]"></div>
                                </template>
                            </td>
                        </tr>
                        <!-- 住所（番地以下） -->
                        <tr v-if="dataInit.addr2Flg == 1">
                            <th v-if="dataInit.addr2HissuFlg == 1" class="required">{{$t("sh030.labels.streetAddress")}}</th>
                            <th v-else class="optional">{{$t("sh030.labels.streetAddress")}}</th>
                            <td>
                                <input-check id="tdkAddr2Comp" type="text" name="tdkAddr2Comp" size="50" v-model="reqModel.tdkAddr2Comp" maxlength="100"/><br/>
                                <div v-html="descriptionInfo[23]"></div>
                            </td>
                        </tr>
                        <!-- 住所（マンション名・会社名等） -->
                        <tr v-if="dataInit.addr3Flg == 1">
                            <th v-if="dataInit.addr3HissuFlg == 1" class="required">{{$t("sh030.labels.apartmentName")}}</th>
                            <th v-else class="optional">{{$t("sh030.labels.apartmentName")}}</th>
                            <td>
                                <input-check id="tdkAddr3Comp" type="text" name="tdkAddr3Comp" size="50" v-model="reqModel.tdkAddr3Comp" maxLength="100"/><br/>
                                <div v-html="descriptionInfo[24]"></div>
                            </td>
                        </tr>
                        <tr>
                            <th class="required">
                                <!-- 電話番号※ -->
                                {{$t("sh030.labels.phoneNumber※")}}
                            </th>
                            <td>
                                <input-check type="text" id="tdkTelNoComp" name="tdkTelNoComp" v-model="reqModel.tdkTelNoComp" size="20" maxlength="15" class="tel"/>
                                <br>
                                <div v-html="descriptionInfo[25]"></div>
                            </td>
                        </tr>
                    </template>
                </table>
                
                <!-- BtoB届先直送選択チェックボックス -->
                <template v-if="dataInit.siteFlg == 1">
                    <label v-if="dataInit.tdkChokuLabel" for="tdkChokuFlg" class="select_add">
                        <input type="checkbox" id="tdkChokuFlg" true-value="1" false-value="0" v-model="reqModel.tdkChokuFlg" class="margin-left-10px">
                        <b> {{dataInit.tdkChokuLabel }}</b>
                    </label>
                    <p class="mb16 input-p-desc-css" v-if="descriptionInfo[48]">
                        <span v-html="descriptionInfo[48]"></span>
                    </p>
                </template>

                <label v-if="dataInit.kokyakuNo != 999999999 && dataInit.tdkOtherFlg == 1 && dataInit.tdkCount == 1 && dataInit.catalogFlg != 1 && reqModel.radioGroup == 2" for="tdkListSubmitFlg" class="select_add">
                    <input v-if="teikiFlg == 1" type="checkbox" id="tdkListSubmitFlg" value="1" v-model="reqModel.tdkListSubmitFlg" class="margin-left-10px" disabled="true">
                    <input v-else type="checkbox" id="tdkListSubmitFlg" true-value="1" false-value="0" v-model="reqModel.tdkListSubmitFlg" class="margin-left-10px" :disabled="reqModel.tdkSubmitFlg == 1">
                    <!-- 届先リストに登録する ゲスト購入のときは表示しない オプションが入っている場合はチェック固定にして動かせないようにする -->
                    <b> {{$t("sh030.labels.tdkListSubmit")}}</b>
                </label>

                <!-- こちらの住所は今回のご注文でのみ有効です。（会員登録の住所変更手続きはされません。) -->
                <p class="mb64 input-p-desc-css" v-if="dataInit.catalogOrderOpt != 1">
                    <span v-if="teikiFlg == 1" v-html="descriptionInfo[45]"></span>
                    <span v-else v-html="descriptionInfo[31]"></span>
                </p>
            </div>
            <!-- ヤマト営業所止置きサービスの場合 -->
            <div class="sh030-body-yamato-area" id="hide_table_3" v-if="reqModel.radioGroup==4">
                <table  class="sh030-body-order-tbl-person" >
                    <tr>
                        <th class="required">
                            <!-- お名前※ -->
                            {{$t("sh030.labels.name")}}
                        </th>
                        <td>
                            <div class="sh030-form-column">
                                <input type="hidden" v-model="reqModel.tdkNo">
                                <!-- 姓 -->
                                <template v-if="dataInit.name2Flg == 1">
                                    <label class="sh030-form-column-num02">{{$t("pt330.labels.surname")}}</label>
                                </template>
                                <template v-else>
                                    <label class="sh030-form-column-num02">{{$t("pt330.labels.name1")}}</label>
                                </template>
                                <!--配送先名を自分宛にするフラグを利用しない場合-->
                                <template v-if="dataInit.tdkMyAddrFlg == 0">
                                    <input-check type="text" id="tdkNm1" name="tdkNm1"
                                            v-model="reqModel.tdkNm1" size="20"
                                            maxlength="50" class="multi"/>
                                </template>
                                <!--配送先名を自分宛にするフラグを利用する場合-->
                                <template v-else>
                                    <input-check type="text" id="tdkNm1" name="tdkNm1"
                                            disabled 
                                            v-model="reqModel.tdkNm1" size="20" 
                                            maxlength="50" class="multi input-p-okuriNushiKana2-css"/>
                                </template>
                                <!-- 名2 -->
                                <template v-if="dataInit.name2Flg == 1">
                                    <label class="sh030-form-column-num02">{{$t("pt330.labels.name2")}}</label>
                                    <!--配送先名を自分宛にするフラグを利用しない場合-->
                                    <template v-if="dataInit.tdkMyAddrFlg == 0">
                                        <input-check type="text" id="tdkNm2" name="tdkNm2"
                                                    v-model="reqModel.tdkNm2" size="20"
                                                    maxlength="50" class="multi"/>
                                    </template>
                                    <!--配送先名を自分宛にするフラグを利用する場合-->
                                    <template v-else>
                                        <input-check type="text" id="tdkNm2" name="tdkNm2"
                                                    disabled
                                                    v-model="reqModel.tdkNm2" size="20"
                                                    maxlength="50" class="multi input-p-okuriNushiKana2-css"/>
                                    </template>
                                </template>
                                <br/>
                            </div>
                            <div v-html="descriptionInfo[17]"></div>
                        </td>
                    </tr>
                    <tr>
                        <!-- フリガナ -->
                        <th v-if="dataInit.kanaHissuFlg == 1" class="required">{{$t("sh030.labels.nameKana")}}</th>
                        <th v-else class="optional">{{$t("sh030.labels.nameKana")}}</th>
                        <td>
                            <div class="sh030-form-column">
                                <!-- 姓 -->
                                <template v-if="dataInit.name2Flg == 1">
                                    <label class="sh030-form-column-num02">{{$t("pt330.labels.surname")}}</label>
                                </template>
                                <template v-else>
                                    <label class="sh030-form-column-num02">{{$t("pt330.labels.name1")}}</label>
                                </template>
                                <!--配送先名を自分宛にするフラグを利用しない場合-->
                                <template v-if="dataInit.tdkMyAddrFlg == 0">
                                    <input-check type="text" id="tdkKana1" name="tdkKana1"
                                            v-model="reqModel.tdkKana1" size="20"
                                            maxlength="50" class="multi"/>
                                </template>
                                <!--配送先名を自分宛にするフラグを利用する場合-->
                                <template v-else>
                                    <input-check type="text" id="tdkKana1" name="tdkKana1"
                                            disabled 
                                            v-model="reqModel.tdkKana1" size="20"
                                            maxlength="50" class="multi input-p-okuriNushiKana2-css"/>
                                </template>
                                <!-- 名 -->
                                <template v-if="dataInit.name2Flg == 1">
                                    <label class="sh030-form-column-num02">{{$t("pt330.labels.name2")}}</label>
                                    <!--配送先名を自分宛にするフラグを利用しない場合-->
                                    <template v-if="dataInit.tdkMyAddrFlg == 0">
                                        <input-check type="text" id="tdkKana2" name="tdkKana2"
                                                v-model="reqModel.tdkKana2" size="20"
                                                maxlength="50" class="multi"/>
                                    </template>
                                    <!--配送先名を自分宛にするフラグを利用する場合-->
                                    <template v-else>
                                        <input-check type="text" id="tdkKana2" name="tdkKana2"
                                                disabled 
                                                v-model="reqModel.tdkKana2" size="20"
                                                maxlength="50" class="multi input-p-okuriNushiKana2-css"/>
                                    </template>
                                </template>
                                <br/>
                            </div>
                            <div v-html="descriptionInfo[18]"></div>
                        </td>
                    </tr>
                    <tr>
                        <th class="required">
                            <!-- 電話番号※ -->
                            {{$t("sh030.labels.phoneNumber※")}}
                        </th>
                        <td>
                            <input-check type="text" id="tdkTelNo" name="tdkTelNo" v-model="reqModel.tdkTelNo" size="20" maxlength="15" class="tel"/>
                            <br>
                            <div v-html="descriptionInfo[25]"></div>
                        </td>
                    </tr>
                    <tr>
                        <th class="required">
                            <!-- 営業所コード -->
                            {{$t("sh030.labels.yaOfficeCd")}}
                        </th>
                        <td class="office-add" ontouchstart="">
                            <input-check type="text" id="tdkOfficeCd" name="tdkOfficeCd" v-model="reqModel.tdkAddr2" @input="getYaOfficeInfo" size="13" maxlength="7" class="form-control-sm"/>
                            <!-- ヤマト営業所サイトへ -->
                            <a :href="dataInit.yaOfficeUrl" target="_blank">
                                {{$t("sh030.labels.officeUrl")}}
                                <img :src="getImageOpenNewWindow" class="mr-1">
                            </a>
                            <div v-html="descriptionInfo[40]"></div>
                        </td>
                    </tr>
                    <tr>
                        <!-- 営業所情報 -->
                        <th>{{$t("sh030.labels.yaOfficeAddress")}}</th>
                        <td>
                            <template v-if="reqModel.tdkAddr2.length >= 6">
                                <span v-if="reqModel.tdkAddr1">
                                    {{$t("sh030.labels.zip")}}{{reqModel.tdkZipCd}}<br>
                                    {{$t("sh030.labels.yaOfficeNm")}}：{{reqModel.tdkAddr3}}<br>
                                    {{$t("sh030.labels.orderAddr")}}：{{reqModel.tdkAddr1}}<br>
                                    {{$t("common.labels.phoneNumber")}}：{{dataInit.yaOfficeTel}}
                                </span>
                                <span class="input-p-desc-css" v-else-if="!isLoading">
                                    {{$t("sh030.labels.officeNotFound")}}
                                </span>
                            </template>
                            <template v-else>
                                {{$t("sh030.labels.officeInfo")}}
                            </template>
                        </td>
                    </tr>
                </table>
                <!-- こちらの住所は今回のご注文でのみ有効です。（会員登録の住所変更手続きはされません。) -->
                <p class="mb64 input-p-desc-css" v-if="dataInit.catalogOrderOpt != 1">
                    <span v-html="descriptionInfo[31]"></span>
                </p>
            </div>
            <br>
            <!--送り主（BtoC） -->
            <div class="sh030-body-okurinushi-area" id="hide_table_4" v-if="reqModel.okuriNushiCheckBox ==  1 && dataInit.csmInfoOption == 1 && dataInit.siteFlg != 1">
                <div id="tdkOkuriScroll" class="sh030-body-subtitle"><h4>送主情報</h4></div>
                <table class="sh030-body-order-tbl-person" >
                    <tr>
                        <th class="required">
                            <!-- お名前※ -->
                            {{$t("sh030.labels.name")}}
                        </th>
                        <td>
                            <div class="sh030-form-column left ">
                                <input type="hidden" v-model="reqModel.okuriNushiNo">
                                <!-- 姓 -->
                                <template v-if="dataInit.name2Flg == 1">
                                    <label class="sh030-form-column-num02">{{$t("pt330.labels.surname")}}</label>
                                </template>
                                <template v-else>
                                    <label class="sh030-form-column-num02">{{$t("pt330.labels.name1")}}</label>
                                </template>
                                <!--配送先名を自分宛にするフラグを利用しない場合-->
                                <template v-if="dataInit.tdkMyAddrFlg == 0">
                                    <input-check type="text" id="okuriNushiNm1" name="okuriNushiNm1"
                                            v-model="reqModel.okuriNushiNm1" size="20"
                                            maxlength="50" class="multi"/>
                                </template>
                                <!--配送先名を自分宛にするフラグを利用する場合-->
                                <template v-else>
                                    <input-check type="text" id="okuriNushiNm1" name="okuriNushiNm1"
                                            disabled
                                            v-model="reqModel.okuriNushiNm1" size="20" 
                                            maxlength="50" class="multi input-p-okuriNushiKana2-css"/>
                                </template>
                                <!-- 名2 -->
                                <template v-if="dataInit.name2Flg == 1">
                                    <label class="sh030-form-column-num02">{{$t("pt330.labels.name2")}}</label>
                                    <!--配送先名を自分宛にするフラグを利用しない場合-->
                                    <template v-if="dataInit.tdkMyAddrFlg == 0">
                                        <input-check type="text" id="okuriNushiNm2" name="okuriNushiNm2"
                                                    v-model="reqModel.okuriNushiNm2" size="20"
                                                    maxlength="50" class="multi"/>
                                    </template>
                                    <!--配送先名を自分宛にするフラグを利用する場合-->
                                    <template v-else>
                                        <input-check type="text" id="okuriNushiNm2" name="okuriNushiNm2"
                                                    disabled 
                                                    v-model="reqModel.okuriNushiNm2" size="20"
                                                    maxlength="50" class="multi input-p-okuriNushiKana2-css"/>
                                    </template>
                                </template>
                            </div>
                            <!-- 送主を検索-->
                            <button class="tdk-btn" type="button" v-if="dataInit.kokyakuNo != 999999999"
                             @click="searchOkuriNushiList()">{{$t("sh030.labels.okuriAddressee")}}</button>
                            <br />
                            <div v-html="descriptionInfo[17]"></div>
                        </td>
                    </tr>
                    <tr>
                        <!-- フリガナ -->
                        <th v-if="dataInit.kanaHissuFlg == 1" class="required">{{$t("sh030.labels.nameKana")}}</th>
                        <th v-else class="optional">{{$t("sh030.labels.nameKana")}}</th>
                        <td>
                            <div class="sh030-form-column">
                                <!-- 姓 -->
                                <template v-if="dataInit.name2Flg == 1">
                                    <label class="sh030-form-column-num02">{{$t("pt330.labels.surname")}}</label>
                                </template>
                                <template v-else>
                                    <label class="sh030-form-column-num02">{{$t("pt330.labels.name1")}}</label>
                                </template>
                                <!--配送先名を自分宛にするフラグを利用しない場合-->
                                <template v-if="dataInit.tdkMyAddrFlg == 0">
                                    <input-check type="text" id="okuriNushiKana1" name="okuriNushiKana1"
                                            v-model="reqModel.okuriNushiKana1" size="20"
                                            maxlength="50" class="multi"/>
                                </template>
                                <!--配送先名を自分宛にするフラグを利用する場合-->
                                <template v-else>
                                    <input-check type="text" id="okuriNushiKana1" name="okuriNushiKana1"
                                            disabled
                                            v-model="reqModel.okuriNushiKana1" size="20"
                                            maxlength="50" class="multi input-p-okuriNushiKana2-css"/>
                                </template>
                                <!-- 名 -->
                                <template v-if="dataInit.name2Flg == 1">
                                    <label class="sh030-form-column-num02">{{$t("pt330.labels.name2")}}</label>
                                    <!--配送先名を自分宛にするフラグを利用しない場合-->
                                    <template v-if="dataInit.tdkMyAddrFlg == 0">
                                        <input-check type="text" id="okuriNushiKana2" name="okuriNushiKana2"
                                                v-model="reqModel.okuriNushiKana2" size="20"
                                                maxlength="50" class="multi"/>
                                    </template>
                                    <!--配送先名を自分宛にするフラグを利用する場合-->
                                    <template v-else>
                                        <input-check type="text" id="okuriNushiKana2" name="okuriNushiKana2"
                                                disabled 
                                                v-model="reqModel.okuriNushiKana2" size="20"
                                                maxlength="50" class="multi input-p-okuriNushiKana2-css"/>
                                    </template>
                                </template>
                                <br/>
                            </div>
                            <div v-html="descriptionInfo[18]"></div>
                        </td>
                    </tr>
                    <tr>
                        <th class="required">
                            <!-- 郵便番号 -->
                            {{$t("common.labels.postalCode")}}
                        </th>
                        <td ontouchstart="">
                            <input-check type="text" id="okuriNushiZipCd" name="okuriNushiZipCd" v-model="reqModel.okuriNushiZipCd" @on-input-change="onBlurZipCd(); setAddr('okuriNushi')" size="13" maxlength="8" class="zip sh030-form-column"/>
                            <!-- 住所自動入力 -->
                            <button  @click="setAddr('okuriNushi')"> {{$t("common.labels.addressSearch")}}</button>
                            <div v-html="descriptionInfo[19]"></div>
                        </td>
                    </tr>
                    <!-- 都道府県 -->
                    <template v-if="dataInit.kenPulldownDispFlg == 1">
                        <tr>
                            <th class="required">
                                <!-- 都道府県 -->
                                {{$t("sh030.labels.prefectures")}}
                            </th>
                            <td>
                                <select v-model="reqModel.okuriNushiKenCd" id="okuriNushiKenCd">
                                    <option v-for="ken in dataInit.kenList" :key="ken.KEY" :value="ken.KEY" :selected="ken.KEY == reqModel.okuriNushiKenCd">{{ken.VALUE}}</option>
                                </select>
                                <br>
                                <div v-html="descriptionInfo[20]"></div>
                            </td>
                        </tr>
                    </template>
                    <template v-else>
                        <input type="hidden" v-model="reqModel.okuriNushiKenCd" />
                    </template>
                    <tr>
                        <!-- 住所（市区郡町村） -->
                        <th class="required">{{$t("sh030.labels.cityAndCounty")}}</th>
                        <td>
                            <input-check id="okuriNushiAddr1" type="text" name="okuriNushiAddr1" size="50" v-model="reqModel.okuriNushiAddr1" maxlength="100"/>
                            <br/>
                             <template v-if="dataInit.kenPulldownDispFlg == 1">
                                <div v-html="descriptionInfo[21]"></div>
                            </template>
                            <template v-else>
                                <div v-html="descriptionInfo[22]"></div>
                            </template>
                        </td>
                    </tr>
                    <!-- 住所（番地以下） -->
                    <tr v-if="dataInit.addr2Flg == 1">
                        <th v-if="dataInit.addr2HissuFlg == 1" class="required">{{$t("sh030.labels.streetAddress")}}</th>
                        <th v-else class="optional">{{$t("sh030.labels.streetAddress")}}</th>
                        <td>
                            <input-check id="okuriNushiAddr2" type="text" name="okuriNushiAddr2" size="50" v-model="reqModel.okuriNushiAddr2" maxlength="100"/><br/>
                            <div v-html="descriptionInfo[23]"></div>
                        </td>
                    </tr>
                    <!-- 住所（マンション名・会社名等） -->
                    <tr v-if="dataInit.addr3Flg == 1">
                        <th v-if="dataInit.addr3HissuFlg == 1" class="required">{{$t("sh030.labels.apartmentName")}}</th>
                        <th v-else class="optional">{{$t("sh030.labels.apartmentName")}}</th>
                        <td>
                            <input-check id="okuriNushiAddr3" type="text" name="okuriNushiAddr3" size="50" v-model="reqModel.okuriNushiAddr3" maxLength="100"/><br/>
                            <div v-html="descriptionInfo[24]"></div>
                        </td>
                    </tr>
                    <tr>
                        <th class="required">
                            <!-- 電話番号※ -->
                            {{$t("sh030.labels.phoneNumber※")}}
                        </th>
                        <td>
                            <input-check type="text" id="okuriNushiTelNo" name="okuriNushiTelNo" v-model="reqModel.okuriNushiTelNo" size="20" maxlength="15" class="tel"/>
                            <br>
                            <div v-html="descriptionInfo[25]"></div>
                        </td>
                    </tr>
                </table>

                <label v-if="dataInit.kokyakuNo != 999999999 && dataInit.csmInfoOption == 1 && dataInit.catalogFlg != 1 && reqModel.okuriNushiCheckBox == true" for="csmListSubmitFlg" class="select_add">
                    <input type="checkbox" id="csmListSubmitFlg" true-value="1" false-value="0" v-model="reqModel.csmListSubmitFlg" class="margin-left-10px" :disabled="reqModel.csmSubmitFlg == 1">
                    <!-- 送主リストに登録する ゲスト購入のときは表示しない オプションが入っている場合はチェック固定にして動かせないようにする -->
                    <b>{{$t("sh030.labels.csmListSubmit")}}</b>
                </label>

                <!-- こちらの住所は今回のご注文でのみ有効です。（会員登録の住所変更手続きはされません。) -->
                <p  class="mb64 input-p-desc-css" v-if="dataInit.catalogOrderOpt != 1">
                    <span v-html="descriptionInfo[31]"></span>
                </p>
            </div>
            <!--送り主（BtoB） -->
            <div class="sh030-body-okurinushi-area" id="hide_table_4" v-if="reqModel.okuriNushiCheckBox ==  1 && dataInit.csmInfoOption == 1  && dataInit.siteFlg == 1">
                <div id="tdkOkuriScroll" class="sh030-body-subtitle"><h4>送主情報</h4></div>
                <table class="sh030-body-order-tbl-person" >
                    <tr>
                        <th class="required">
                            <!-- 会社名 -->
                            {{$t("sh030.labels.okurikaisyame")}}
                        </th>
                        <td>
                            <div class="sh030-form-column left ">
                                <input type="hidden" v-model="reqModel.okuriNushiNo">
                                <input-check type="text" id="okuriNushiNm1Comp" name="okuriNushiNm1Comp"
                                        v-model="reqModel.okuriNushiNm1Comp" size="50"
                                        maxlength="50" class="multi"/>
                            </div>
                            <!-- 送主を検索-->
                            <button class="tdk-btn" type="button" v-if="dataInit.kokyakuNo != 999999999"
                             @click="searchOkuriNushiCompList()">{{$t("sh030.labels.okuriAddressee")}}</button>
                            <br />
                            <span v-html="descriptionInfo[3]"></span>
                        </td>
                    </tr>
                    <tr>
                        <!-- 会社名カナ -->
                        <th v-if="dataInit.kanaHissuFlg == 1" class="required">{{$t("sh030.labels.kaisyamekana")}}</th>
                        <th v-else class="optional">{{$t("sh030.labels.okurikaisyamekana")}}</th>
                        <td>
                            <div class="sh030-form-column">
                                <!--配送先名を自分宛にするフラグを利用しない場合-->
                                    <input-check type="text" id="okuriNushiKana1Comp" name="okuriNushiKana1Comp"
                                            v-model="reqModel.okuriNushiKana1Comp" size="50"
                                            maxlength="50" class="multi"/>
                                <br/>
                            </div>
                            <span v-html="descriptionInfo[4]"></span>
                        </td>
                    </tr>
                    <!-- 部署名 -->
                    <tr>
                        <th class="optional">{{$t("sh030.labels.bushoName")}}</th>
                        <td>
                            <input id="okuriNushiNm2Comp" type="text" name="okuriNushiNm2Comp" size="50" v-model="reqModel.okuriNushiNm2Comp" maxlength="50"/><br/>
                            <span v-html="descriptionInfo[41]"></span>
                        </td>
                    </tr>
                    <!-- 担当者名 -->
                    <tr>
                        <th class="optional">{{$t("sh030.labels.tantoshame")}}</th>
                        <td>
                            <input id="okuriNushiNm3Comp" type="text" name="okuriNushiNm3Comp" size="50" v-model="reqModel.okuriNushiNm3Comp" maxLength="50"/><br/>
                            <span v-html="descriptionInfo[42]"></span>
                        </td>
                    </tr>
                    <!-- 表示敬称 -->
                    <tr>
                        <th class="required">
                            <!-- 表示敬称 -->
                            {{$t("sh030.labels.hyoujiKeisyo")}}
                        </th>
                        <td>
                            <select v-model="reqModel.okuriHyoujiKeisyo" id="okuriHyoujiKeisyo">
                                <option v-for="ken in dataInit.okuriHyoujiKeisyoList" :key="ken.KEY" :value="ken.KEY" :selected="ken.KEY == reqModel.okuriHyoujiKeisyo">{{ken.VALUE}}</option>
                            </select>
                            <br>
                        </td>
                    </tr>
                    <tr>
                        <th class="required">
                            <!-- 郵便番号 -->
                            {{$t("common.labels.postalCode")}}
                        </th>
                        <td ontouchstart="">
                            <input-check type="text" id="okuriNushiZipCdComp" name="okuriNushiZipCdComp" v-model="reqModel.okuriNushiZipCdComp" @on-input-change="onBlurZipCd(); setAddr('okuriNushiComp')" size="13" maxlength="8" class="zip sh030-form-column"/>
                            <!-- 住所自動入力 -->
                            <button  @click="setAddr('okuriNushiComp')"> {{$t("common.labels.addressSearch")}}</button>
                            <div v-html="descriptionInfo[19]"></div>
                        </td>
                    </tr>
                    <!-- 都道府県 -->
                    <template v-if="dataInit.kenPulldownDispFlg == 1">
                        <tr>
                            <th class="required">
                                <!-- 都道府県 -->
                                {{$t("sh030.labels.prefectures")}}
                            </th>
                            <td>
                                <select v-model="reqModel.okuriNushiKenCdComp" id="okuriNushiKenCdComp">
                                    <option v-for="ken in dataInit.kenList" :key="ken.KEY" :value="ken.KEY" :selected="ken.KEY == reqModel.okuriNushiKenCdComp">{{ken.VALUE}}</option>
                                </select>
                                <br>
                                <div v-html="descriptionInfo[20]"></div>
                            </td>
                        </tr>
                    </template>
                    <template v-else>
                        <input type="hidden" v-model="reqModel.okuriNushiKenCdComp" />
                    </template>
                    <tr>
                        <!-- 住所（市区郡町村） -->
                        <th class="required">{{$t("sh030.labels.cityAndCounty")}}</th>
                        <td>
                            <input-check id="okuriNushiAddr1Comp" type="text" name="okuriNushiAddr1Comp" size="50" v-model="reqModel.okuriNushiAddr1Comp" maxlength="100"/>
                            <br/>
                             <template v-if="dataInit.kenPulldownDispFlg == 1">
                                <div v-html="descriptionInfo[21]"></div>
                            </template>
                            <template v-else>
                                <div v-html="descriptionInfo[22]"></div>
                            </template>
                        </td>
                    </tr>
                    <!-- 住所（番地以下） -->
                    <tr v-if="dataInit.addr2Flg == 1">
                        <th class="optional">{{$t("sh030.labels.streetAddress")}}</th>
                        <td>
                            <input-check id="okuriNushiAddr2Comp" type="text" name="okuriNushiAddr2Comp" size="50" v-model="reqModel.okuriNushiAddr2Comp" maxlength="100"/><br/>
                            <div v-html="descriptionInfo[23]"></div>
                        </td>
                    </tr>
                    <!-- 住所（マンション名・会社名等） -->
                    <tr v-if="dataInit.addr3Flg == 1">
                        <th class="optional">{{$t("sh030.labels.apartmentName")}}</th>
                        <td>
                            <input-check id="okuriNushiAddr3Comp" type="text" name="okuriNushiAddr3Comp" size="50" v-model="reqModel.okuriNushiAddr3Comp" maxLength="100"/><br/>
                            <div v-html="descriptionInfo[24]"></div>
                        </td>
                    </tr>
                    <tr>
                        <th class="required">
                            <!-- 電話番号※ -->
                            {{$t("sh030.labels.phoneNumber※")}}
                        </th>
                        <td>
                            <input-check type="text" id="okuriNushiTelNoComp" name="okuriNushiTelNoComp" v-model="reqModel.okuriNushiTelNoComp" size="20" maxlength="15" class="tel"/>
                            <br>
                            <div v-html="descriptionInfo[25]"></div>
                        </td>
                    </tr>
                </table>

                <label v-if="dataInit.kokyakuNo != 999999999 && dataInit.csmInfoOption == 1 && dataInit.catalogFlg != 1 && reqModel.okuriNushiCheckBox == true" for="csmListSubmitFlg" class="select_add">
                    <input type="checkbox" id="csmListSubmitFlg" true-value="1" false-value="0" v-model="reqModel.csmListSubmitFlg" class="margin-left-10px" :disabled="reqModel.csmSubmitFlg == 1">
                    <!-- 送主リストに登録する ゲスト購入のときは表示しない オプションが入っている場合はチェック固定にして動かせないようにする -->
                    <b>{{$t("sh030.labels.csmListSubmit")}}</b>
                </label>

                <!-- こちらの住所は今回のご注文でのみ有効です。（会員登録の住所変更手続きはされません。) -->
                <p  class="mb64 input-p-desc-css" v-if="dataInit.catalogOrderOpt != 1">
                    <span v-html="descriptionInfo[31]"></span>
                </p>
            </div>
            <br>
            <!-- 商品情報（数量とは、のしとか）-->
            <table v-if="dataInit.cartSplitUseFlg != 1">
                <thead>
                    <!-- 商品名 -->
                    <th class="sh030TblTh80Style">{{$t('common.labels.productName')}}</th>
                    <!-- 数量 -->
                    <th class="sh030TblTh10Style" style="width:10%">{{$t('common.labels.quantity')}}</th>
                    <!-- 匹数 -->
                    <th class="sh030TblTh10Style" v-if="dataInit.auraOption == 1" style="width:10%">{{$t('common.labels.animalQty')}}</th>
                    <th class="sh030TblTh10Style" v-if="dataInit.displayHanbaiSuuFlg != 0" style="width:20%"></th>
                    <!-- 操作 -->
                    <th  class="sh030TblTh10Style" v-if="dataInit.noshiOption == 1 && dataInit.noshiButtonShowFlg == 1" style="width:13%">{{$t('sh030.labels.noshiSetting')}}</th>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in dataInit.itemTdkList" :key="index">
                        <!-- 商品名 -->
                        <td  :aria-label="$t('common.labels.productName')">
                            <div class="itemNm">
                                <span class="autoHatchuNgIcon mr-2" v-if="dataInit.autoHatchuOpt == 1 && item.AUTO_HACHU_FLG == 0"></span>
                                <span class="cartOndo" v-if="stringNvl(item.ONDO_NM,'') != ''">【{{item.ONDO_NM}}】</span>
                                {{item.ITEM_NM1}}
                            </div>
                            <div class="noshiInfo">{{item.NOSHI_INFO}}</div>
                        </td>
                        <!-- 数量 -->
                        <td  :aria-label="$t('common.labels.quantity')" style="width:10%">
                           <!--<input-number class="sh030TblInputNumStyle" v-model="item.QTY" :maxlength="5"/>-->
                           {{item.QTY}}
                        </td>
                        <!-- 匹数 -->
                        <td v-if="dataInit.auraOption == 1 && item.SYUKKA_NUM <= 1" :aria-label="$t('common.labels.animalQty')" style="width:10%">
                           {{"-"}}
                        </td>
                        <td v-else-if="dataInit.auraOption == 1 && item.SYUKKA_NUM > 1" :aria-label="$t('common.labels.animalQty')" style="width:10%">
                           {{item.ANIMAL_QTY}}
                        </td>
                        <!-- 商品在庫を見る-->
                        <td v-if="dataInit.displayHanbaiSuuFlg != 0" style="width:20%">
                           <!--<input-number class="sh030TblInputNumStyle" v-model="item.QTY" :maxlength="5"/>-->
                           <span class="hanbaiQtyInfo" v-if="item.HANBAI_QTY_DISPLAY && item.HANBAI_QTY_DISPLAY === 1">
                                <a href="#" @click.prevent="showModal(item.ITEM_CD,item.ITEM_NM1)" >{{$t('common.labels.productZaikoConf')}}</a>
                                <ModalComponent
                                v-if="isModalVisible"
                                :show="isModalVisible"
                                :tableData="tableData"
                                :selectedShouhin="selectedShouhin"
                                :selectedShouhinLst="selectedShouhinLst"
                                :note="note"
                                @close="isModalVisible = false"/>
                            </span>
                        </td>
                        <!--変更-->
                        <td class="cart-link cart-num sh030ButtomSty" v-if="dataInit.noshiOption == 1 && dataInit.noshiButtonShowFlg == 1 " style="width:13%">
                            <input v-if="item.NOSHI_NG_KBN == '0'" type="button" 
                                :disabled =" item.QTY == 0"
                                @click="doSetShiNo(item.ITEM_CD,item.QTY,item.ITEM_NM1)" :value="$t('common.buttons.changeNoshi')">
                        </td>
                    </tr>
                </tbody>
            </table>
            <br>
            <table class="sh030-body-order-tbl-person sh030-body-order-tbl-mb32" id="hide_table_haiso" v-if="isTdkInfoVisible">
                <tr id="tdkYmdScroll" v-if="isTdkYmdVisible">
                    <!-- お届け希望日 -->
                    <th id="hopeDay_lbl">{{$t("sh060.labels.deliveryDates")}}</th>
                    <td bgcolor="#FFFFFF" height="120" class="td-res-height">
                        <!-- 指定なし -->
                        <input id="radio1" type="radio" name="radioGroup1" value="1" v-model="reqModel.radioGroup1" :disabled="(dataInit.itemTdkYmdHissuFlg == 1) || dataInit.displayHanbaiSuuFlg != 0" @click="hopeDayRadio(1)"/>
                        <label for="radio1">：{{$t("sh060.labels.unspecified")}}</label>
                        <span class="sh030-txt-shukka-yoteibi" v-if="reqModel.radioGroup1 == 1 && dataInit.shukkaYoteibi && dataInit.displayHanbaiSuuFlg != 0">出荷予定日：{{dataInit.shukkaYoteibi}}</span>
                        <div class="sh030-txt-zaiko-warn" v-if="reqModel.radioGroup1 == 1 && errorMessages && errorMessages.length && dataInit.displayHanbaiSuuFlg != 0">
                            <div class="error-message-warn">{{$t("warning.labels.zaikoCheck")}}</div>
                            <div class="error-message-warn">
                                <label v-for="error in errorMessages" :key="error">・{{ error }}<br></label>
                            </div>
                        </div>
                        <!-- 指定あり(1回のみ) -->
                        <input id="radio2" type="radio" name="radioGroup1" value="2" v-model="reqModel.radioGroup1" :disabled="(dataInit.itemTdkYmdErrFlg == 1)" @click="hopeDayRadio(2)"/>
                        <label for="radio2">：{{radio2Label}}</label>
                        <span style="display:none" id="radio2_lbl">{{radio2Label}}</span>
                        <br>
                        <select name="hopeDay" id="hopeDay" v-model="reqModel.hopeDay" v-if="reqModel.radioGroup1 == 2" @change="hopeDayc">
                            <option v-for="day in dataInit.tdkYmdList" :value="day.KEY" :key="day.KEY" >{{day.VALUE}}</option>
                        </select>
                       <select name="hopeDay" id="hopeDay" class="hopeDay" v-model="reqModel.hopeDay" v-else disabled @change="hopeDayc">
                            <option v-for="day in dataInit.tdkYmdList" :value="day.KEY" :key="day.KEY" >{{day.VALUE}}</option>
                        </select>
                        <span class="sh030-txt-shukka-yoteibi" v-if="reqModel.radioGroup1 == 2 && dataInit.shukkaYoteibi && dataInit.displayHanbaiSuuFlg != 0 && reqModel.hopeDay">出荷予定日：{{dataInit.shukkaYoteibi}}</span>
                        <div class="sh030-txt-zaiko-warn" v-if="reqModel.radioGroup1 == 2 && errorMessages && errorMessages.length && dataInit.displayHanbaiSuuFlg != 0 && reqModel.hopeDay">
                            <div class="error-message-warn">{{$t("warning.labels.zaikoCheck")}}</div>
                            <div class="error-message-warn">
                                <label v-for="error in errorMessages" :key="error">・{{ error }}<br></label>
                            </div>
                        </div>
                        <br v-if="reqModel.radioGroup1 == 2"/>
                        <!-- 自動発注利用する and 決済方法がクレジット、掛払、代引き、全額ポイントのとき and 届先数が1以下のときのみ -->
                        <template v-if="isHatchuShow && tdkMonths && tdkMonths.length > 0">
                            <!-- 指定あり(複数回) ※2ヶ月先までカレンダーから日付を指定して発注が可能です。 -->
                            <input id="radio3" type="radio" name="radioGroup1" value="3" v-model="reqModel.radioGroup1" :disabled="(dataInit.itemTdkYmdErrFlg == 1)" class="mt-3" @click="hopeDayRadio(3)"/>
                            <label for="radio3">：{{$t("sh030.labels.autoHatchu")}}</label>
                            <br>
                            <div v-if="reqModel.radioGroup1 == 3">
                                
                                <div v-for="(tdkMonth, tmIndex) in tdkMonths" :key="'tm_' + tmIndex" class="row" style="margin: 0 -15px -15px 0 !important;">
                                    <div class="dt-col">
                                        <div>{{tdkMonth.monthNm}}</div>
                                        <div class="dt-table">
                                            <div class="dt-row">
                                                <div class="dt-cell" style="background: #FFD1D1">日</div>
                                                <div class="dt-cell">月</div>
                                                <div class="dt-cell">火</div>
                                                <div class="dt-cell">水</div>
                                                <div class="dt-cell">木</div>
                                                <div class="dt-cell">金</div>
                                                <div class="dt-cell" style="background:#CCF9FF">土</div>
                                            </div>
                                            
                                            <div class="dt-row" v-for="(week, wIndex) in tdkMonth.weeks" :key="'w_' + wIndex">
                                                <div class="dt-cell" v-for="(day, dIndex) in week" :key="dIndex" 
                                                    :style="(day.youbi == 0 || day.isHoliday) ? 'background: #FFD1D1; color:#990000;' : (day.youbi == 6 ? 'background:#CCF9FF; color:#0000FF;' : (day.val ? '' : 'background: #DEDEDE;'))">
                                                    <span>{{(day && day.val) ? day.text : ''}}</span>
                                                    <input class="ml-1" v-if="day && day.val && day.canSelect && calendarSet.includes(day.val)" type="checkbox" :id="'day_' + day.val" name="hopeDays" :value="day.val" v-model="reqModel.hopeDayList"  @change="onHopeDayListChange">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br>
                        </template>
                        <div class="sh030-txt-zaiko-warn" v-if="reqModel.radioGroup1 == 3 && errorMessages && errorMessages.length > 0 && dataInit.displayHanbaiSuuFlg != 0 && reqModel.hopeDayList.length > 0">
                            <div class="error-message-warn">{{$t("warning.labels.zaikoCheck")}}</div>
                            <div class="error-message-warn">
                                <label v-for="error in errorMessages" :key="error">・{{ error }}<br></label>
                            </div>
                        </div>

                        <span v-html="descriptionInfo[32]"></span>

                        <!-- 自動発注不可メッセージ -->
                        <span class="autoHatchuNg1" v-if="dataInit.autoHatchuOpt == 1 && !autoHatchuFlg"><br>{{$t("sh030.labels.autoHatchuNg1")}}</span>
                        <span class="autoHatchuNg2" v-if="dataInit.autoHatchuOpt == 1 && !['1', '2', '82' , '6', '993'].includes(dataInit.reqModel.kessaiCd)"><br>{{$t("sh030.labels.autoHatchuNg2")}}</span>
                        
                        <!-- 定期商品が表示される際のメッセージ -->
                        <span v-html="descriptionInfo[46]" v-if="showTeikiFlg"></span>
                    </td>
                </tr>
                <!--定期商品リスト -->
                <tr v-if="showTeikiFlg && dataInit.cartSplitUseFlg != 1">
                    <th>{{$t("sh030.labels.teikiItem")}}</th>
                    <td>
                        <table >
                            <tr>
                                <th>{{$t('common.labels.productCode')}}</th>
                                <th>{{$t('common.labels.productName')}}</th>
                                <th>{{$t('sh060.labels.quantity')}}</th>
                            </tr>
                            <tr v-for="(item,index) in reqModel.resultTeikiItemList" :key="index">
                                <td>
                                    <span>{{item.S_ITEM_CD}}</span>
                                </td>
                                <td>
                                    <span class="teikiOndo" v-if="stringNvl(item.ONDO_NM,'') != ''">【{{item.ONDO_NM}}】</span>
                                    <span>{{item.ITEM_NM}}</span>
                                </td>
                                <td>
                                    <span>{{item.QTY}}</span>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr v-bind:id="dataInit.tdkkibouFlg == 1 ? '' : 'tdkYmdScroll'" v-if="dataInit.tdkTimeFlg == 1 && dataInit.cartSplitUseFlg != 1 && dataInit.itemTdkHstmErrFlg != 1">
                    <th>
                        <!-- お届け希望時間 -->
                        {{$t("sh060.labels.desiredDeliveryTime")}}
                    </th>
                    <td>
                        <select :disabled="false" name="hopeTime" id="hopeTime" v-model="reqModel.hopeTime">
                            <option v-for="hopeTime in dataInit.hopeTimeList" :key="hopeTime.KEY" :value="hopeTime.KEY" >{{hopeTime.VALUE}}</option>
                        </select>
                        <br>
                        <span v-html="descriptionInfo[33]"></span>
                    </td>
                </tr>
            </table>
            <!-- ギフト設定 -->
            <table id="sh030_table_giftSetting" class="sh030-body-order-tbl-person sh030-body-order-tbl-mb32"
                v-if="(dataInit.nosiFlg == 1 || dataInit.housoushiFlg == 1 || dataInit.noshiNaireFlg == 1) && dataInit.cartSplitUseFlg != 1">
                <tr id="tdkGiftScroll" v-if="dataInit.nosiFlg == 1">
                    <th>
                        <!-- のし -->
                        {{$t("sh030.labels.works")}}
                    </th>
                    <td>
                        <select name="" id="sagyoKanriKomokuCd" v-model="reqModel.sagyoKanriKomokuCd">
                            <option value=""></option>
                            <option v-for="noshi in dataInit.noshiList" :key="noshi.KEY" :value="noshi.KEY">{{noshi.VALUE}}</option>
                        </select>
                        <div v-html="descriptionInfo[28]"></div>
                    </td>
                </tr>
                <tr v-if="dataInit.housoushiFlg == 1">
                    <th>
                        <!-- 包装紙 -->
                        {{$t("sh030.labels.wrappingPaper")}}
                    </th>
                    <td>
                        <select id="sagyoKanriKomokuCd2" v-model="reqModel.sagyoKanriKomokuCd2">
                            <option value=""></option>
                            <option v-for="housoushi in dataInit.housoushiList" :key="housoushi.KEY" :value="housoushi.KEY">{{housoushi.VALUE}}</option>
                        </select>
                        <span v-html="descriptionInfo[27]"></span>
                    </td>
                </tr>
                <tr v-if="dataInit.noshiNaireFlg == 1">
                    <th>
                        <!-- 送り主名 -->
                        {{$t("sh030.labels.senderName")}}
                    </th>
                    <td>
                        <!-- 送り主名1 -->
                        {{$t("common.labels.okurinushi1Label")}}&nbsp;
                        <input-check id="noshiNaire1" class="multi input-okurinushi-mei-css" type="text" v-model="reqModel.noshiNaire1"/>
                        <div v-html="descriptionInfo[29]"></div>
                        <br>
                        <!-- 送り主名2 -->
                        {{$t("common.labels.okurinushi2Label")}}&nbsp;
                        <input-check id="noshiNaire2" class="multi input-okurinushi-mei-css" type="text" v-model="reqModel.noshiNaire2"/>
                        <div v-html="descriptionInfo[30]"></div>
                        <br>
                        <span v-html="descriptionInfo[35]"></span>
                    </td>
                </tr>
            </table>
            <div class="btnSubmitsh030">
                <!-- 前ページに戻る -->
                <li><button @click="goBack" type="button">{{$t("common.buttons.backtothepreviouspage")}}</button></li>
                <!-- 次へ進む / 注文内容確認画面へ / 変更 -->
                <li>
                    <button @click="doConfirmSubmit" type="button" :disabled="errorMessages && errorMessages.length > 0" :class="{ btn: errorMessages && errorMessages.length > 0 }">
                        {{ dataInit.stepBasedFlg == 1 ? $t("common.buttons.proceedNext") : dataInit.catalogFlg == 1 ? $t("sh030.buttons.confirmationOfOrderContents") : $t("common.buttons.change") }}
                    </button>
                </li>
            </div>
        </div>
        
        <span style="display:none" id="name_lbl">{{$t("sh030.labels.name")}}</span>
        <span style="display:none" id="nameKana_lbl">{{$t("sh030.labels.nameKana")}}</span>
        <span style="display:none" id="nameComp_lbl">{{$t("sh030.labels.kaisyame")}}</span>
        <span style="display:none" id="nameKanaComp_lbl">{{$t("sh030.labels.kaisyamekana")}}</span>
        <span style="display:none" id="mail_lbl">{{$t("sh030.labels.deliveryMailAddress")}}</span>
        <!-- 都道府県 -->
        <span style="display:none" id="prefectures_lbl">{{$t('sh030.labels.prefectures')}}</span>
        <!-- 郵便番号 -->
        <span style="display:none" id="postalCode_lbl">{{$t('sh030.labels.postalCode')}}</span>
        <!-- 電話番号 -->
        <span style="display:none" id="phoneNumber_lbl">{{$t('common.labels.phoneNumber')}}</span>
        <!-- 営業所コード -->
        <span style="display:none" id="yaOfficeCd_lbl">{{$t('sh030.labels.yaOfficeCd')}}</span>
        <!-- 届先メールアドレス -->
        <span style="display:none" id="deliveryMailAddress_lbl">{{$t("sh030.labels.deliveryMailAddress")}}</span>
        <alert-confirm
            v-if="isZipMsgAlert"
            :msgConfirm="zipMsg"
            :isButtonCancel="false"
            :okAction="isZipRequiredMsgClose"
            @closedModal="isZipMsgAlert=false"
        ></alert-confirm>

        <alert-confirm
            v-if="isItemCntZeroMsgAlert"
            :msgConfirm="itemCntZeroMsg"
            :isButtonCancel="true"
            :okAction="doAction"
            @closedModal="isItemCntZeroMsgAlert=false"
            size="md"
        ></alert-confirm>

        <alert-confirm
            v-if="isItemCntZeroOfOneTdkMsgAlert"
            :msgConfirm="itemCntZeroOfOneTdkMsg"
            :isButtonCancel="false"
            @closedModal="isItemCntZeroOfOneTdkMsgAlert=false"
            size="md"
        ></alert-confirm>
        <!--アラート表示-->
        <alert-confirm
            v-if="isModalShow"
            :msgConfirm="msgConfirm"
            :okAction="doAction"
            :isButtonCancel="isButtonCancel">
        </alert-confirm>

        <CC212InputPostal v-if="isCCInputPostalShow" @modal-close="isCCInputPostalShow = false" :propTdkZip1="cc212Prop.propTdkZip1" 
            :propTdkZip2="cc212Prop.propTdkZip2" :propIdx="cc212Prop.propIdx" @set-addr-value="setAddrValue" />
        <CC211SearchTdkList v-if="isSearchTdkList" @modal-close="isSearchTdkList = false" :propKokyakuNo="cc211Prop.propKokyakuNo" :propTdkKbn="0" @set-addr-value="setValueCc211" />
        <CC211SearchTdkList1 v-if="isSearchTdkCompList" @modal-close="isSearchTdkCompList = false" :propKokyakuNo="cc211Prop.propKokyakuNo" :propTdkKbn="0" @set-addr-value="setCompValueCc211" />
        <CC211SearchOkuriNushiList v-if="isSearchOkurinushiList" @modal-close="isSearchOkurinushiList = false" :propKokyakuNo="cc211Prop.propKokyakuNo" :propTdkKbn="1" :listType="1" @set-addr-value="setOkurinushiValueCc211" />
        <CC211SearchOkuriNushiList1 v-if="isSearchOkurinushiCompList" @modal-close="isSearchOkurinushiCompList = false" :propKokyakuNo="cc211Prop.propKokyakuNo" :propTdkKbn="1" :listType="1" @set-addr-value="setOkurinushiCompValueCc211" />
        <CC215SearchDairiList v-if="isSearchDairiList" @modal-close="isSearchDairiList = false" :propDesc1="dataInit.kokyakuCdNm" 
            :propDesc2="dataInit.dairiNm" @set-addr-value="setValueCc215" />
    </div>
</template>
<script>
/* 
* Import libs and componnents
*/
import common from "assets/js/common";
import axios from "assets/js/request";
import Loading from 'vue-loading-overlay';
import InputCheck from "components/InputCheck";
import InputNumber from 'components/InputNumber';
import AlertConfirm from "components/AlertConfirm";
import mapInfo from "assets/js/mapInfo";
import EventBus from "assets/js/eventBus";
import SiteConstants from 'assets/const/SiteConstants.json';
import Constants from 'assets/const/Constants.json';
import Message from 'components/MessageEcSite';
import CC212InputPostal from '../search/CC212InputPostal';
import CC211SearchTdkList from '../search/CC211SearchTdkList';
import CC211SearchTdkList1 from '../search/CC211SearchTdkList';
import CC211SearchOkuriNushiList from '../search/CC211SearchTdkList';
import CC211SearchOkuriNushiList1 from '../search/CC211SearchTdkList';
import CC215SearchDairiList from '../search/CC215SearchDairiList';
import ModalComponent from '../popup/HanbaiSuuSettingPopup.vue';

export default {
    /* 
    * Name of component
    */
    name: "SH030ShopperTdkInfo",
    props:{
        ptInitData: {
            type: Object,
            default: null,
        }
    },
    /* 
    * Declare components
    */
    components: {
        InputCheck,
        Loading,
        AlertConfirm,
        Message,
        InputNumber,
        CC212InputPostal,
        CC211SearchTdkList,
        CC211SearchTdkList1,
        CC211SearchOkuriNushiList,
        CC211SearchOkuriNushiList1,
        CC215SearchDairiList,
        ModalComponent
    },/* 
    * Declare variable and set default value
    */
    data() {
        return {
            totalRecord: 50,
            fromRecord: 1,
            toRecord: 10,
            pageSize: 10,
            pageNo: 1,
            goto: 0,
            isModalVisible: false,
            tableData: [],
            selectedShouhinLst : [],
            selectedShouhin: '',
            errorMessages: [],
            note: '',
            dataInit:{
                descriptionInfo:{}
            },
            radioGroup:"",
            siteFlg:0,
            reqModel:{
                teikiFlg : 0,
                hopeDayList: []
            },
            mapInfoResp:{},
            mapInfoChangeTdkFlag:false,
            isZipMsgAlert:false,
            isItemCntZeroMsgAlert:false,
            isItemCntZeroOfOneTdkMsgAlert:false,
            zipMsg:"",
            itemCntZeroMsg:"",
            itemCntZeroOfOneTdkMsg:"",
            SiteConstants: SiteConstants,
            Constants: Constants,
            SH030_PART:'sh030',
            listMessValid:[],
            mapMessValid:[],
            listIdErr:[],
            isCCInputPostalShow:false,
            isSearchTdkList:false,
            isSearchTdkCompList:false,
            isSearchOkurinushiList:false,
            isSearchOkurinushiCompList:false,
            isSearchDairiList:false,
            cc212Prop:{},
            cc211Prop:{},
            getGiftCd:null,
            disableOption:null,
            descriptionInfo:[],
            NO_CART_ERR : "001",
            CART_INFO_INVALID_ERR : "002",
            itemTdkYmdHissuFlg :0,
            itemTdkYmdErrFlg :0,
            site: "",
            tdkInfoFlg : false,
            paySkipFlg : false,
            confirmFlg : false,
            completeFlg : false,
            showTeikiFlg : false,
            showBetuOrder : false,
            isLoading: false,
            getImageOpenNewWindow: common.getImages('openNewWindow'),
            queryData : null,
            sh060 : {
                teikiFlg : 0
            },
            tdkMonths: [],
            firstTdkYmd: '',
            disableMon: false,
            disableTue: false,
            holidays: [],
            calendarSet: [],
            isModalShow:false,
            msgConfirm:'',
            isButtonCancel: true,
            actionFlg:0,
            isAddr23Flg: false,
            autoHatchuFlg: true,
            teikiFlg: 0,
		    isCheckingHopeDayList: false,
            hopeDayCheckRequestNo: 0
        }
    },
    /* 
    * Initialize
    */
    mounted() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        var tranferdata = {};
        if (sessionStorage['sh030TranferData']) {
          tranferdata = JSON.parse(sessionStorage['sh030TranferData']);
          sessionStorage.removeItem('sh030TranferData');
        }

        if (_this.ptInitData) {
            _this.isLoading = true;
            _this.errorMessages = _this.ptInitData.messages;
            try {
                if (_this.ptInitData.status != 'OK') {
                    if(_this.ptInitData.respCode == _this.NO_CART_ERR){
                        _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query:{pageNo:2}});
                        return;
                    }
                    if(_this.ptInitData.respCode == _this.CART_INFO_INVALID_ERR){
                        _this.$router.push({ name: 'Warning' });
                        return;
                    }
                }

                _this.dataInit = _this.ptInitData;
                _this.reqModel = Object.assign({}, _this.reqModel, _this.ptInitData.reqModel);
                
                if(_this.reqModel.tdkFlg == '3') {
                    _this.reqModel.radioGroup ='2';
                } else if(_this.reqModel.tdkFlg == '1') {
                    _this.reqModel.radioGroup ='1';
                }

                if (_this.reqModel.tdkMSeq == 1 && _this.dataInit.tdkCount == 1) {
                    _this.reqModel.radioGroup ='2';
                }

                _this.tdkInfoFlg = true;
                if (_this.dataInit.paySkipFlg == 0) {
                    _this.paySkipFlg = true;
                }
                if (_this.dataInit.tdkMyAddrFlg == 1) {
                    _this.reqModel.tdkNm1 = _this.reqModel.kokyakuNm1;
                    _this.reqModel.tdkNm2 = _this.reqModel.kokyakuNm2;
                    _this.reqModel.tdkKana1 = _this.reqModel.kokyakuKana1 ;
                    _this.reqModel.tdkKana2 = _this.reqModel.kokyakuKana2;
                }
                //代理注文者の場合
                if (_this.dataInit.dairiInputKbn == '1' && _this.reqModel.radioGroup3 == null) {
                    _this.reqModel.radioGroup3 = '1'
                }
                if (_this.dataInit.dairiInputKbn == '1' && _this.reqModel.radioGroup3 == 2) {
                    _this.showBetuOrder = true;
                }
                _this.reqModel.dairiInputKbn = _this.dataInit.dairiInputKbn;
                _this.reqModel.dairiOrderKbn = _this.dataInit.dairiOrderKbn;
                _this.confirmFlg = true;
                _this.completeFlg = true;
                if (_this.dataInit.radioGroup1 == null || _this.dataInit.radioGroup1 == '1') {
                    _this.disableOption = true;
                }
                // 説明マスタ
                _this.descriptionInfo = _this.dataInit.descriptionInfo;
                // サイトメールを説明マスタに入れ込む
                _this.descriptionInfo[2] = _this.descriptionInfo[2].replace("[1]", _this.dataInit.siteMail);
                if (_this.ptInitData.siteFlg!=1) _this.siteFlg = 0;

                if (_this.reqModel.radioGroup3 == undefined) _this.reqModel.radioGroup3 = '1';
                if (_this.reqModel.kokyakuSexKbn == null){
                    _this.reqModel.kokyakuSexKbn = _this.dataInit.sexKbnList[0].KEY;
                }

                _this.reqModel.resultTeikiItemList = _this.ptInitData.resultTeikiItemList;
                if (_this.reqModel.resultTeikiItemList != null && _this.reqModel.resultTeikiItemList != '') {
                    _this.reqModel.teikiKessaiCd = _this.reqModel.resultTeikiItemList[0].KESSAI_CD;
                    _this.showTeikiFlg = true;
                    _this.reqModel.teikiFlg = 1;
                } else {
                    _this.showTeikiFlg = false;
                    _this.reqModel.teikiFlg = 0;
                }

                if (tranferdata && tranferdata.reqModel) {
                    _this.reqModel = Object.assign(_this.reqModel, tranferdata.reqModel);
                }
                if (tranferdata && tranferdata.dataInit) {
                    //DBから取得した最新のデータで上書きする
                    for(var i=0;i<tranferdata.dataInit.itemTdkList.length;i++){
                        var item = tranferdata.dataInit.itemTdkList[i];
                        item.NOSHI_INFO = _this.dataInit.itemTdkList[i].NOSHI_INFO;
                    }
                    _this.dataInit = Object.assign(_this.dataInit, tranferdata.dataInit);
                }

                _this.setInitialRadioGroup1();

                // 送主情報の変更ボタンの場合、チェックを入れる
                if (_this.reqModel.scrollId == 3 && _this.dataInit.kokyakuNo != 999999999) {
                    _this.reqModel.okuriNushiCheckBox = 1;
                }

                if (_this.dataInit.catalogFlg == 1) {
                    _this.reqModel.radioGroup ='2';
                }

                _this.filterTdkDateByItem();
                _this.initTdkMonths();

                // 注文内容確認画面から遷移する場合、押された変更ボタンによって表示位置を変更する。
                _this.$nextTick(() => {
                    if (_this.reqModel.scrollId != null) {
                        _this.scroll(_this.reqModel.scrollId);
                    }
                });

                _this.teikiFlg = _this.sh060.teikiFlg;

                _this.$forceUpdate();
            } catch (error) {
                common.errorAPI(error);
            } finally {
                _this.isLoading = false;
            }
        } else {
            _this.isLoading = true;
            axios.get(_this.$UrlConstants.ECSITE +_this.$UrlConstants.SH030 + _this.$UrlConstants.DO_INIT).then(function(response) {
                if (response.data.status != 'OK') {
                    if(response.data.respCode == _this.NO_CART_ERR) {
                        _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 2}});
                        return;
                    }
                    if(response.data.respCode == _this.CART_INFO_INVALID_ERR) {
                        _this.$router.push({ name: 'Warning' });
                        return;
                    }
                }

                _this.dataInit = response.data;
                _this.reqModel = Object.assign({}, _this.reqModel, response.data.reqModel);
                
                if(_this.reqModel.tdkFlg == '3'){
                    _this.reqModel.radioGroup ='2';
                } else if(_this.reqModel.tdkFlg == '1'){
                    _this.reqModel.radioGroup ='1';
                }

                if (_this.reqModel.tdkMSeq == 1 && _this.dataInit.tdkCount == 1) {
                    _this.reqModel.radioGroup ='2';
                }

                _this.tdkInfoFlg = true;
                if (_this.dataInit.paySkipFlg == 0){
                    _this.paySkipFlg = true;
                }
                if (_this.dataInit.tdkMyAddrFlg == 1) {
                    _this.reqModel.tdkNm1 = _this.reqModel.kokyakuNm1;
                    _this.reqModel.tdkNm2 = _this.reqModel.kokyakuNm2;
                    _this.reqModel.tdkKana1 = _this.reqModel.kokyakuKana1 ;
                    _this.reqModel.tdkKana2 = _this.reqModel.kokyakuKana2;
                }
                //代理注文者の場合
                if (_this.dataInit.dairiInputKbn == '1' && _this.reqModel.radioGroup3 == null) {
                    _this.reqModel.radioGroup3 = '1'
                }
                if (_this.dataInit.dairiInputKbn == '1' && _this.reqModel.radioGroup3 == 2) {
                    _this.showBetuOrder = true;
                }
                _this.reqModel.dairiInputKbn = _this.dataInit.dairiInputKbn;
                _this.reqModel.dairiOrderKbn = _this.dataInit.dairiOrderKbn;
                _this.confirmFlg = true;
                _this.completeFlg = true;
                if(_this.dataInit.radioGroup1 == null || _this.dataInit.radioGroup1 == '1'){
                    _this.disableOption = true;
                }
                // 説明マスタ
                _this.descriptionInfo = _this.dataInit.descriptionInfo;
                // サイトメールを説明マスタに入れ込む
                _this.descriptionInfo[2] = _this.descriptionInfo[2].replace("[1]", _this.dataInit.siteMail);
                if(response.data.siteFlg!=1) _this.siteFlg = 0;

                if(_this.reqModel.radioGroup3 == undefined) _this.reqModel.radioGroup3 = '1';
                if(_this.reqModel.kokyakuSexKbn == null){
                    _this.reqModel.kokyakuSexKbn = _this.dataInit.sexKbnList[0].KEY;
                }

                if(tranferdata && tranferdata.dataInit && tranferdata.reqModel){
                    //DBから取得した最新のデータで上書きする
                    for(var i=0;i<tranferdata.dataInit.itemTdkList.length;i++){
                        var item = tranferdata.dataInit.itemTdkList[i];
                        item.NOSHI_INFO = _this.dataInit.itemTdkList[i].NOSHI_INFO;
                    }
                    _this.reqModel = Object.assign(_this.reqModel, tranferdata.reqModel);
                }
                if(tranferdata && tranferdata.dataInit){
                    _this.dataInit = Object.assign(_this.dataInit, tranferdata.dataInit);
                }
                _this.setInitialRadioGroup1();
                if (_this.isTdkYmdVisible && _this.reqModel.radioGroup1 == '2' && _this.reqModel.hopeDay) {
                    _this.hopeDayc();
                }

                // 送主情報の変更ボタンの場合、チェックを入れる
                if (_this.reqModel.scrollId == 3 && _this.dataInit.kokyakuNo != 999999999) {
                    _this.reqModel.okuriNushiCheckBox = 1;
                }

                _this.filterTdkDateByItem();
                _this.initTdkMonths();

                // 注文内容確認画面から遷移する場合、押された変更ボタンによって表示位置を変更する。
                _this.$nextTick(() => {
                    if (_this.reqModel.scrollId != null) {
                        _this.scroll(_this.reqModel.scrollId);
                    }
                });

                _this.$forceUpdate();
                _this.isLoading = false;
            }).catch(function(error) {
                _this.isLoading = false;
                common.errorAPI(error);
            });
        }
        var amazonCheckoutSessionId =  sessionStorage['amazonCheckoutSessionId'];
        
        if(amazonCheckoutSessionId != null) {
            _this.reqModel.amazonCheckoutSessionId = amazonCheckoutSessionId;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH060 + "/doInitAmazonPay", _this.reqModel).then(function(response) {
                _this.reqModel.kokyakuNm1 = response.data.orderInfo["KOKYAKU_NM1"];
                _this.reqModel.kokyakuNm2 = response.data.orderInfo["KOKYAKU_NM2"];
                _this.reqModel.kokyakuZip = response.data.orderInfo["KOKYAKU_ZIP"];
                _this.reqModel.kokyakuAddr1 = response.data.orderInfo["KOKYAKU_ADDR1"];
                _this.reqModel.kokyakuAddr2 = response.data.orderInfo["KOKYAKU_ADDR2"];
                _this.reqModel.kokyakuAddr3 = response.data.orderInfo["KOKYAKU_ADDR3"];
                _this.reqModel.kokyakuTel = response.data.orderInfo["KOKYAKU_PHONE"];
                _this.reqModel.kokyakuMail1 = response.data.orderInfo["KOKYAKU_MAIL"];
                sessionStorage['amazonPayInfo'] =  response.data.orderInfo['AMAZON_PAY_INFO'];
            }).catch(function(error) {
                _this.is3DLoding = false;
                common.errorAPI(error);
            }).finally(function() {
                _this.$emit("event-loading", false);
            });
        }
        EventBus.$on("closed", function() {
            _this.isZipMsgAlert = false;
            _this.isItemCntZeroMsgAlert = false;
            _this.isItemCntZeroOfOneTdkMsgAlert = false;
            _this.isSearchTdkList = false;
            _this.isSearchOkurinushiList = false;
            _this.isSearchTdkCompList = false;
            _this.isSearchOkurinushiCompList = false;
            _this.isSearchDairiList = false;
            _this.isModalShow = false;
        });
        EventBus.$on('closed2', function(msgConfirm){
            if(msgConfirm==_this.$t("sh030.labels.zipCodeDoesNotExist")) {
                _this.isZipRequiredMsgClose();
            }
        });

    },
    /* 
    * Methods
    */
    methods: {
        /*
        * 配達希望日のラジオボタン初期値設定
        * radio1、radio2のdisabled状態を確認し、有効な選択肢だけを設定する
        */
        setInitialRadioGroup1:function(){
            var _this = this;
            // 配達希望日欄が非表示の場合は、初期値を設定しない
            if (!_this.isTdkYmdVisible) {
                return;
            }
            // radio1：「指定なし」のdisabled条件
            var radio1Disabled = (_this.dataInit.itemTdkYmdHissuFlg == 1) ||
                _this.dataInit.displayHanbaiSuuFlg != 0;
            // radio2：「指定あり（1回のみ）」のdisabled条件
            var radio2Disabled = _this.dataInit.itemTdkYmdErrFlg == 1;
            var preferredValue = null;

            // 商品情報から、優先して選択するラジオボタンを決定する
            if (((_this.dataInit.itemTdkYmdHissuFlg == 1) &&
                (_this.dataInit.itemTdkYmdErrFlg == 0)) ||
                _this.dataInit.displayHanbaiSuuFlg != 0) {
                preferredValue = '2';
            } else if (((_this.dataInit.itemTdkYmdHissuFlg == 0) &&
                (_this.dataInit.itemTdkYmdErrFlg == 1)) &&
                _this.dataInit.displayHanbaiSuuFlg == 0) {
                preferredValue = '1';
            } else if ((_this.dataInit.itemTdkYmdHissuFlg == 0) &&
                (_this.dataInit.itemTdkYmdErrFlg == 0)) {
                preferredValue = '1';
            }

            // radioGroup1が未設定の場合は、優先値が有効ならその値を設定する
            if (_this.reqModel.radioGroup1 == undefined) {
                if (preferredValue == '1' && !radio1Disabled) {
                    _this.reqModel.radioGroup1 = '1';
                } else if (preferredValue == '2' && !radio2Disabled) {
                    _this.reqModel.radioGroup1 = '2';
                // 優先値がdisabledの場合は、もう一方の有効なラジオボタンを設定する
                } else if (!radio1Disabled) {
                    _this.reqModel.radioGroup1 = '1';
                } else if (!radio2Disabled) {
                    _this.reqModel.radioGroup1 = '2';
                }
            // 既存値がdisabledになっている場合は、有効な選択肢へ切り替える
            } else if (_this.reqModel.radioGroup1 == '1' && radio1Disabled) {
                _this.reqModel.radioGroup1 = radio2Disabled ? undefined : '2';
            } else if (_this.reqModel.radioGroup1 == '2' && radio2Disabled) {
                _this.reqModel.radioGroup1 = radio1Disabled ? undefined : '1';
            }
        },
       /*
        * Function stringNvl
        */
        stringNvl: function(strVal, defVal){
            if(strVal==undefined){
                return defVal;
            }else{
                return strVal;
            }
        },
        // ゲスト注文者の郵便番号変更時
        onGuestZipChange: function() {
            // 注文者住所に送る場合のみ、郵便番号から配達希望日・時間帯リスト再取得
            if (this.reqModel.radioGroup == '1') {
                this.onBlurZipCd();
            }
        },
        // フォーカスが外れた時
        onBlurZipCd: function() {
            var _this = this;
            var tdkZip = "";
            var okuriZip = "";
            var zipArr = "";
            var zip1 = "";
            var zip2 = "";
            var okuriZipArr = "";
            var okuriZip1 = "";
            var okuriZip2 = "";

            var radioGroup = _this.reqModel.radioGroup;
            var radioGroup1 = _this.reqModel.radioGroup1;
            var okuriCheck = _this.reqModel.okuriNushiCheckBox;
            var ajaxReqModel = {};
            // BtoC サイトの場合
            if(_this.dataInit.siteFlg != 1){
                tdkZip = _this.reqModel.tdkZipCd;
                okuriZip = _this.reqModel.okuriNushiZipCd;
            // BtoB サイトの場合
            }else{
                tdkZip = _this.reqModel.tdkZipCdComp;
                okuriZip = _this.reqModel.okuriNushiZipCdComp;
            }
            // 2:別のお届け先に送る
            if(radioGroup == 2 && (tdkZip == null || tdkZip.replace("-", "").length != 7)) {
                return;
            }
            // 2:別のお届け先に送る
            if(radioGroup == 2 && (tdkZip != null || tdkZip.replace("-", "").length == 7)) {
                zipArr = tdkZip.split("-");
                // ハイフンが含まれている場合
                if ( tdkZip.includes("-") ) {
                    zip1 = zipArr[0];
                    zip2 = zipArr[1];
                } else {
                    zip1 = tdkZip.substring(0,3);
                    zip2 = tdkZip.substring(3,7);
                }
                tdkZip = zip1 + "-" + zip2;
            }

            // 送り主の郵便番号が入力されている場合
            if (okuriCheck == 1 && (okuriZip != null && okuriZip.replace("-", "").length == 7)) {
                okuriZipArr = okuriZip.split("-");
                if (okuriZip.includes("-")) {
                    okuriZip1 = okuriZipArr[0];
                    okuriZip2 = okuriZipArr[1];
                } else {
                    okuriZip1 = okuriZip.substring(0,3);
                    okuriZip2 = okuriZip.substring(3,7);
                }
                okuriZip = okuriZip1 + "-" + okuriZip2;
            }

            _this.isLoading = true;
            var ajaxZipCd = "";
            var ajaxKenCd = "";
            // 注文者住所に送る場合
            if (radioGroup == '1') {
                ajaxZipCd = _this.reqModel.kokyakuZip;
                ajaxKenCd = _this.reqModel.kokyakuKenCd;
            // BtoC サイトの場合
            } else if(_this.dataInit.siteFlg != 1){
                ajaxZipCd = _this.reqModel.tdkZipCd;
                ajaxKenCd = _this.reqModel.tdkKenCd;
            // BtoB サイトの場合
            } else{
                ajaxZipCd = _this.reqModel.tdkZipCdComp;
                ajaxKenCd = _this.reqModel.tdkKenCdComp;
            }
            if (!ajaxZipCd && radioGroup != '1') {
                ajaxZipCd = _this.reqModel.kokyakuZip;
                ajaxKenCd = _this.reqModel.kokyakuKenCd;
            }
            if(_this.containsZenkaku(ajaxZipCd)) {
                _this.isLoading = false;
                return;
            }
            // BtoC サイトの場合
            if(_this.dataInit.siteFlg != 1){
                if (!tdkZip && radioGroup == 1) {
                    tdkZip = _this.reqModel.kokyakuZip;
                }
                _this.reqModel.tdkZipCd = tdkZip;
                _this.reqModel.okuriNushiZipCd = okuriZip;
            // BtoB サイトの場合
            }else{
                if (!tdkZip && radioGroup == 1) {
                    tdkZip = _this.reqModel.kokyakuZip;
                }
                _this.reqModel.tdkZipCdComp = tdkZip;
                _this.reqModel.okuriNushiZipCdComp = okuriZip;
               
            }
            // 郵便番号から配達希望日更新
            ajaxReqModel = {
                ajaxFlg:'4',
                hopeDay: _this.reqModel.hopeDay,
                itemTdkList:_this.dataInit.itemTdkList,
                radioGroup: radioGroup,
                ajaxZipCd: ajaxZipCd,
                ajaxKenCd: ajaxKenCd
            }
            axios.post(_this.$UrlConstants.ECSITE +_this.$UrlConstants.SH030 + _this.$UrlConstants.DO_AJAX, ajaxReqModel).then(function(ajaxRespone) {
                _this.dataInit.tdkYmdList = ajaxRespone.data.tdkYmdList;
                _this.dataInit.hopeTimeList = ajaxRespone.data.hopeTimeList;
                if(radioGroup1 == 1) {
                    _this.errorMessages = ajaxRespone.data.messages;
                    _this.dataInit.shukkaYoteibi = ajaxRespone.data.shukkaYoteibi;
                } else if (radioGroup1 == 2 && _this.dataInit.displayHanbaiSuuFlg != 0) {
                    _this.errorMessages = null;
                    _this.dataInit.shukkaYoteibi = "";
                    _this.reqModel.hopeDay = "";
                }
                _this.isLoading = false;
                _this.filterTdkDateByItem();
                _this.initTdkMonths();
                _this.$forceUpdate();
            }).catch(function(error) {
                _this.isLoading = false;
                _this.$emit("event-loading", false);
                common.errorAPI(error);
                common.scrollTop();
            });
        },
        showModal(itemCd,itemNm) {
            var _this = this;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH030 + "/getShipYotei", itemCd+":"+itemNm).then(function(response) {
                if (response.data && response.data.inventoryItemModelLst) {
                    _this.tableData = response.data.inventoryItemModelLst;
                    _this.selectedShouhinLst = response.data.itemNmLst;
					var shouhin = response.data.colSizList.find(item => item['KEY'] === itemCd);
					_this.selectedShouhin = shouhin ? shouhin['VALUE'] : itemNm;
                    _this.isModalVisible = true;
                    _this.note = response.data.memo;
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
        },
        showPopupBuyZero: function() {
            var _this = this;
            var buyAllCnt = 0;

            for (var i = 0; i < _this.dataInit.itemTdkList.length; i++) {
                buyAllCnt = buyAllCnt + _this.dataInit.itemTdkList[i].QTY;
            }
            if (_this.dataInit.tdkCount == 1 && buyAllCnt == 0) {
                _this.itemCntZeroOfOneTdkMsg = _this.$t("sh030.messages.itemCntZeroOfOneTdkMsg");
                _this.actionFlg = 2;
                _this.isItemCntZeroOfOneTdkMsgAlert = true;
                return;
            }
            if (buyAllCnt == 0){
                _this.itemCntZeroMsg = _this.$t("sh030.messages.itemCntZeroMsg");
                _this.actionFlg = 2;
                _this.isItemCntZeroMsgAlert = true;
                return;
            }
            _this.doOndoCheck();
        },
        doOndoCheck: function() {
            //温度帯のチェック
            var _this = this;
            var ondoTaiErr = false;
            
            if (_this.showTeikiFlg && _this.reqModel.resultTeikiItemList != null && _this.reqModel.resultTeikiItemList != '' && _this.reqModel.resultTeikiItemList.length > 0) {
                for (var i = 0; i < _this.reqModel.resultTeikiItemList.length; i++) {
                    for (var j = 0; j < _this.dataInit.itemTdkList.length; j++) {
                        var ondoTaiNm = _this.dataInit.itemTdkList[j].ONDO_NM;
                        if (ondoTaiNm != _this.reqModel.resultTeikiItemList[i].ONDO_NM) {
                            ondoTaiErr = true;
                            break;
                        }
                    }
                    if (ondoTaiErr) {
                        break;
                    }
                }
            }
            if (ondoTaiErr){
                _this.actionFlg = 99;
                //定期商品と温度帯が一致しない商品が含まれるため、別途送料がかかる場合があります。よろしいですか？
                _this.msgConfirm = _this.$t("sh030.messages.ondoTaiMsg");
                _this.isModalShow = true;
                _this.isButtonCancel = true;
                return;
            }
            _this.submit();
        },

        /*
        * 住所２/住所３が利用するそして必須チェック利用が確認する時でメッセージを戻る
        */
        getAddr23Msg: function(){
            let msg = "";
            //[住所２が利用するそして必須チェック利用が確認する]判定
            let addr2Kakunin = (this.dataInit.addr2Flg == 1 && this.dataInit.addr2HissuFlg == 2);
            //[住所３が利用するそして必須チェック利用が確認する]判定
            let addr3Kakunin = (this.dataInit.addr3Flg == 1 && this.dataInit.addr3HissuFlg == 2);
            
            //ゲストの注文者判定
            let isGuest = (this.dataInit.kokyakuNo == 999999999);
            //ゲストの注文者のアドレス2が空白判定
            let kokyakuAddr2IsEmpty = (this.reqModel.kokyakuAddr2 == "");
            //ゲストの注文者のアドレス3が空白判定
            let kokyakuAddr3IsEmpty = (this.reqModel.kokyakuAddr3 == "");
            
            //[別のお届け先に送る]選択判定
            let IsSelectedTdk = (this.reqModel.radioGroup == 2 && this.dataInit.tdkCount == 1);
            
            //BtoC判定
            let isBtoC = (this.dataInit.siteFlg != 1);
            //BtoB判定
            let isBtoB = (this.dataInit.siteFlg == 1);

            //お届け先（BtoC）のアドレス2が空白判定
            let tdkAddr2IsEmpty = (this.reqModel.tdkAddr2 == "");
            //お届け先（BtoC）のアドレス3が空白判定
            let tdkAddr3IsEmpty = (this.reqModel.tdkAddr3 == "");

            //お届け先（BtoB）のアドレス2が空白判定
            let tdkCompAddr2IsEmpty = (this.reqModel.tdkCompAddr2 == "");
            //お届け先（BtoB）のアドレス3が空白判定
            let tdkCompAddr3IsEmpty = (this.reqModel.tdkCompAddr3 == "");

            //送り主判定
            let isOkurinushi = (this.reqModel.okuriNushiCheckBox ==  1 && this.dataInit.csmInfoOption == 1);
            //送り主（BtoC）のアドレス2が空白判定
            let okurinushiAddr2IsEmpty = (this.reqModel.okuriNushiAddr2 == "");
            //送り主（BtoC）のアドレス3が空白判定
            let okurinushiAddr3IsEmpty = (this.reqModel.okuriNushiAddr3 == "");
            //送り主（BtoB）のアドレス2が空白判定
            let okurinushiCompAddr2IsEmpty = (this.reqModel.okuriNushiAddr2Comp == "");
            //送り主（BtoB）のアドレス3が空白判定
            let okurinushiCompAddr3IsEmpty = (this.reqModel.okuriNushiAddr3Comp == "");
          
            //[注文者情報]
            let addrKokyakuFlg = -1;
            //[お届先情報]
            let addrTdkFlg = -1;
            //[送り主情報]
            let addrOkurinushiFlg = -1;

            let subMsg2 = this.$i18n.t('sh030.labels.streetAddress');
            let subMsg3 = this.$i18n.t('sh030.labels.apartmentName');

            //住所２/住所３が利用するそして必須チェック利用が確認する時
            if (addr2Kakunin || addr3Kakunin) {
                //ゲストの注文者
                if (isGuest && (kokyakuAddr2IsEmpty || kokyakuAddr3IsEmpty)) {
                    if (addr2Kakunin && addr3Kakunin && kokyakuAddr2IsEmpty && kokyakuAddr3IsEmpty){
                        addrKokyakuFlg = 23;
                    }else{
                        if (addr2Kakunin && kokyakuAddr2IsEmpty){
                            addrKokyakuFlg = 2;
                        }
                        if (addr3Kakunin && kokyakuAddr3IsEmpty){
                            addrKokyakuFlg = 3;
                        }
                    }
                }

                //お届け先
                if (IsSelectedTdk){
                    //BtoC
                    if (isBtoC){
                        if (tdkAddr2IsEmpty || tdkAddr3IsEmpty){
                            if (addr2Kakunin && addr3Kakunin && tdkAddr2IsEmpty && tdkAddr3IsEmpty){
                                addrTdkFlg = 23;
                            }else{
                                if (addr2Kakunin && tdkAddr2IsEmpty){
                                    addrTdkFlg = 2;
                                }
                                if (addr3Kakunin && tdkAddr3IsEmpty){
                                    addrTdkFlg = 3;
                                }
                            }
                        }

                    //BtoB
                    }else if (isBtoB){
                        if (tdkCompAddr2IsEmpty || tdkCompAddr3IsEmpty){
                            if (addr2Kakunin && addr3Kakunin && tdkCompAddr2IsEmpty && tdkCompAddr3IsEmpty){
                                addrTdkFlg = 23;
                            }else{
                                if (addr2Kakunin && tdkCompAddr2IsEmpty){
                                    addrTdkFlg = 2;
                                }
                                if (addr3Kakunin && tdkCompAddr3IsEmpty){
                                    addrTdkFlg = 3;
                                }
                            }
                        }
                    }
                }

                //送り主
                if (isOkurinushi){
                    //BtoC
                    if (isBtoC){
                        if (okurinushiAddr2IsEmpty || okurinushiAddr3IsEmpty){
                            if (addr2Kakunin && addr3Kakunin && okurinushiAddr2IsEmpty && okurinushiAddr3IsEmpty){
                                addrOkurinushiFlg = 23;
                            }else{
                                if (addr2Kakunin && okurinushiAddr2IsEmpty){
                                    addrOkurinushiFlg = 2;
                                }
                                if (addr3Kakunin && okurinushiAddr3IsEmpty){
                                    addrOkurinushiFlg = 3;
                                }
                            }
                        }

                    //BtoB
                    }else if (isBtoB){
                        if (okurinushiCompAddr2IsEmpty || okurinushiCompAddr3IsEmpty){
                            if (addr2Kakunin && addr3Kakunin && okurinushiCompAddr2IsEmpty && okurinushiCompAddr3IsEmpty){
                                addrOkurinushiFlg = 23;
                            }else{
                                if (addr2Kakunin && okurinushiCompAddr2IsEmpty){
                                    addrOkurinushiFlg = 2;
                                }
                                if (addr3Kakunin && okurinushiCompAddr3IsEmpty){
                                    addrOkurinushiFlg = 3;
                                }
                            }
                        }
                    }
                }

                //[注文者情報]
                if (addrKokyakuFlg > 0){
                    msg = msg + "[注文者情報]";
                }
                //[お届先情報]
                if (addrTdkFlg > 0){
                    msg = msg + "[お届先情報]";
                }
                //[送り主情報]
                if (addrOkurinushiFlg > 0){
                    msg = msg + "[送り主情報]";
                }
                if (addrKokyakuFlg > 0 || addrTdkFlg > 0 || addrOkurinushiFlg > 0){
                    let flg = [];
                    if (addrKokyakuFlg > 0){
                        flg.push(addrKokyakuFlg);
                    }
                    if (addrTdkFlg > 0){
                        flg.push(addrTdkFlg);
                    }                  
                    if (addrOkurinushiFlg > 0){
                        flg.push(addrOkurinushiFlg);
                    }
                    if (flg.indexOf(23) >= 0 || (flg.indexOf(2) >= 0 && flg.indexOf(3) >= 0)){
                        msg = msg + subMsg2 + "と" + subMsg3;
                    }else if (flg.indexOf(2) >= 0 && flg.indexOf(23) < 0 && flg.indexOf(3) < 0){
                        msg = msg + subMsg2;
                    }else if (flg.indexOf(3) >= 0 && flg.indexOf(23) < 0 && flg.indexOf(2) < 0){
                        msg = msg + subMsg3;
                    }
                    msg = this.$i18n.t('pt400.labels.messg7').replace("{0}", msg);
                }
            }
            return msg;
        },
        /*
        *  POPUP表示処理 actionFlg
        * 1: 登録処理
        * 2: 更新処理
        */
        doAction: function(){
            var _this = this;
            switch (_this.actionFlg) {
                case 1:
                    _this.showPopupBuyZero();
                    break;
                case 2:
                    _this.doOndoCheck();
                    break;
                case 99:
                    _this.submit();
                    break;
                default:
                    break;
            }
            // Hide alert confirm
            _this.isModalShow = false;
            _this.actionFlg = 0;
            _this.isButtonCancel = true;
        },
        doConfirmSubmit: function(){
            let msg = "";
            // 非カート分割 かつ 配達希望日リスト未取得
            if (this.dataInit.cartSplitUseFlg == 0 &&
                (!this.dataInit.tdkYmdList || !this.dataInit.tdkYmdList[1] || !this.dataInit.tdkYmdList[1]['KEY'])) {
                msg = this.$i18n.t('sh030.messages.haitatsuKiboubiLstNull');
                if (msg != ""){
                    this.msgConfirm = msg;
                    this.isModalShow = true;
                    this.isButtonCancel = false;
                    this.actionFlg = 0;
                }
            } else {
                // 住所２/住所３が利用するそして必須チェック利用が確認する時でメッセージを戻る
                msg = this.getAddr23Msg();
                if (msg != ""){
                    this.msgConfirm = msg;
                    this.isModalShow = true;
                    this.isButtonCancel = true;
                    this.actionFlg = 1;
                    this.isAddr23Flg = true;
                }else{
                    this.showPopupBuyZero();
                }
            }
        },

        /*
        * 前のページへ戻るボタン押下処理
        */
        goBack:function(){
            var _this = this;
            var backPageNo = _this.sh060.backPageNo || 16; // 戻り先ページNOが設定されていなければ、カート画面へ戻る
            _this.$router.push({name: _this.SiteConstants.PG010MAIN, query: {pageNo: backPageNo}});
        },

        submit:function(){
            var _this = this;
            _this.isItemCntZeroMsgAlert = false;
            _this.isItemCntZeroOfOneTdkMsgAlert = false;
            _this.setValueDairi();
            _this.reqModel.siteFlg = _this.siteFlg;
            _this.$emit("event-loading", true);
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.SH030_PART);
            _this.reqModel.itemTdkList = _this.dataInit.itemTdkList;
            _this.reqModel.shukkaYoteibi = _this.dataInit.shukkaYoteibi;

            if (_this.dataInit.tdkCount > 1 && _this.reqModel.tdkNo != 0) {
                _this.reqModel.radioGroup = 6;
            }
            
            axios.post(_this.$UrlConstants.ECSITE +_this.$UrlConstants.SH030 + _this.$UrlConstants.DO_UPDATE, _this.reqModel).then(function(response) {
                if(response.data.status=="OK"){
                    // 自動発注を利用する場合のみhopeDayListを保存
                    if(_this.dataInit.autoHatchuOpt == 1 && _this.reqModel.radioGroup1 == '3') {
                        sessionStorage.setItem('hopeDayList', JSON.stringify(_this.reqModel.hopeDayList.sort()));
                    } else {
                        sessionStorage.removeItem('hopeDayList');
                        sessionStorage.removeItem('totalPointKin');
                    }

                    // カート分割を利用する場合
                    if (_this.dataInit.cartSplitUseFlg == 1) {
                        // 配送・ギフト設定画面へ
                        _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 24, backPageNo: 19}});
                    } else if (_this.dataInit.kokyakuNo == 999999999) {
                        // ゲスト購入の場合
                        if (_this.dataInit.paySkipFlg == 1 || _this.sh060.backPageNo == 22 ) {
                            // 支払方法割愛オプション（50502）有のときor注文確認画面から遷移した場合は、注文内容確認画面へ
                            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 22, actionId : 1}});
                        } else {
                            // 支払方法確認画面へ
                            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 21, backPageNo: 19}});
                        }
                    } else {
                        // 会員ログイン時は、注文内容確認画面へ
                        _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 22}});
                    }
                    _this.$emit("event-loading", false);
                }
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                if(error != null && error != undefined){
                    _this.isModalShow = false;
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.SH050_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
                common.scrollTop();
            });
        },
        gotobak:function(){
            var _this = this;
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 22}});
        },
        // 配送希望日選択時 data:1 指定なし  data2 指定あり
		hopeDayRadio:function(data){
            var _this = this;
            // 指定なしの場合
            if (data != 2) {
                // 指定日をリセット
                _this.reqModel.hopeDay = "";
                // 定期商品リストを非表示
                _this.showTeikiFlg = false;
                // 定期フラグをリセット
                _this.reqModel.teikiFlg = 0;
                _this.errorMessages = null;
                _this.dataInit.shukkaYoteibi = "";
                if (_this.dataInit != null && _this.dataInit.tdkYmdList != null 
                    && _this.dataInit.tdkYmdList.length > 0 && _this.dataInit.tdkYmdList[1] && _this.dataInit.tdkYmdList[1]['KEY']) {
                    _this.reqModel.hopeDayNashi = _this.dataInit.tdkYmdList[1].KEY;
                    _this.reqModel.itemTdkList = _this.dataInit.itemTdkList;
                    // BtoC サイトの場合
                    if(_this.dataInit.siteFlg != 1){
                        _this.reqModel.ajaxZipCd = this.reqModel.tdkZipCd,
                        _this.reqModel.ajaxKenCd = this.reqModel.tdkKenCd
                    } else{
                        _this.reqModel.ajaxZipCd = this.reqModel.tdkZipCdComp,
                        _this.reqModel.ajaxKenCd = this.reqModel.tdkKenCdComp
                    }
                    if (!_this.reqModel.ajaxZipCd) {
                        _this.reqModel.ajaxZipCd = this.reqModel.kokyakuZip,
                        _this.reqModel.ajaxKenCd = this.reqModel.kokyakuKenCd
                    }
                    axios.post(_this.$UrlConstants.ECSITE +_this.$UrlConstants.SH030 + "/getShipYoteiCheck", _this.reqModel).then(function(ajaxRespone) {
                        _this.errorMessages = ajaxRespone.data.messages;
                        _this.dataInit.shukkaYoteibi = ajaxRespone.data.shukkaYoteibi;
                    }).catch(function(error) {
                        _this.$emit("event-loading", false);
                        common.errorAPI(error);
                        common.scrollTop();
                    });
                }
            } else if (data == 2) {
                _this.errorMessages = null;
                _this.dataInit.shukkaYoteibi = "";
            }
            _this.$forceUpdate();
        },

        filterTdkDateByItem() {

            // 便種「宅急便（冷凍ドライ）」の商品を含む場合は、月曜日が指定できないようにする
            // もし、リードタイムが1日より長い場合は、火曜も不可とします
            for(let itemTdk of this.dataInit.itemTdkList) {
                if(itemTdk['BINSYU_KBN'] == 121) {
                    this.disableMon = true;
                    if(itemTdk['SYUKKA_LEAD'] > 0) {
                        this.disableTue = true;
                        break;
                    }
                }
            }
            if (this.disableMon  || this.disableTue) {
                for(let i = this.dataInit.tdkYmdList.length - 1; i >= 0; i--) {
                    const tdkYmd = this.dataInit.tdkYmdList[i];
                    if(tdkYmd.KEY) {
                        const tdkDate = new Date(tdkYmd.KEY);
                        const dayOfWeek = tdkDate.getDay();
                        if((this.disableMon && dayOfWeek === 1) || (this.disableTue && dayOfWeek === 2)) {
                            this.dataInit.tdkYmdList.splice(i, 1);
                        }
                    }
                }
            }
        },

        /**
         * 自動発注用カレンダー情報の取得
         */
        initTdkMonths() {
            var _this = this;

            // 配達希望日欄が非表示の場合は、自動発注用情報を復元・取得しない
            if (!_this.isTdkYmdVisible) {
                _this.tdkMonths = [];
                return;
            }
            
            // 自動発注を利用する場合のみ取得
            if (_this.dataInit.autoHatchuOpt != 1) {
                return;
            }
            
            if(sessionStorage['hopeDayList']) {
                _this.reqModel.radioGroup1 = '3';
                _this.reqModel.hopeDayList = JSON.parse(sessionStorage['hopeDayList']);
            }

            _this.tdkMonths = [];
            if (_this.dataInit != null && _this.dataInit.tdkYmdList != null && _this.dataInit.tdkYmdList.length > 0) {
                if (_this.dataInit.tdkYmdList[1] && _this.dataInit.tdkYmdList[1]['KEY']) {
                    _this.firstTdkYmd = _this.dataInit.tdkYmdList[1]['KEY'];
                    let months = _this.getNextTwoMonths(_this.firstTdkYmd);
                    fetch('https://holidays-jp.github.io/api/v1/date.json').then(function(response) {
                        return response.json();
                    }).then(function(holidaysObj) {
                        let keys = Object.keys(holidaysObj);
                        _this.holidays = keys.map(key => key.replace(/-/g, '/'));

                    }).catch(function(error) {
                        console.error('Error:', error);
                    }).finally(function() {
                        if (months) {
                            _this.reqModel.monthLst = months;
                            axios.post(_this.$UrlConstants.ECSITE +_this.$UrlConstants.SH030 + "/getCalendarSetByMonth", _this.reqModel).then(function(ajaxRespone) {
                                _this.calendarSet = ajaxRespone.data.calendarByMonthsLst;
                                if (ajaxRespone.data.hopeDayList) {
                                    _this.reqModel.hopeDayList = ajaxRespone.data.hopeDayList;
                                    sessionStorage.setItem('hopeDayList', JSON.stringify( _this.reqModel.hopeDayList.sort()));
                                }
                            }).catch(function(error) {
                                _this.$emit("event-loading", false);
                                common.errorAPI(error);
                                common.scrollTop();
                            });
                            for (let [index, month] of months.entries()) {

                                let weeks = _this.getWeeksInMonth(month, index);
                                _this.tdkMonths.push({
                                    monthNm: month,
                                    weeks: weeks
                                });
                            }
                        }
                    });
                }
            }
        },

        // 定期予定商品一覧取得
        hopeDayc:function(){
            var _this = this;
            // 配達希望日欄が非表示、または指定日未選択の場合はAPIを呼び出さない
            if (!_this.isTdkYmdVisible || _this.reqModel.radioGroup1 != '2' || !_this.reqModel.hopeDay) {
                return;
            }
            var day = this.reqModel.hopeDay;
            var ajaxReqModel;
            var ajaxZipCd = "";
            var ajaxKenCd = "";
            // BtoC サイトの場合
            if (_this.dataInit.siteFlg != 1) {
                ajaxZipCd = this.reqModel.tdkZipCd;
                ajaxKenCd = this.reqModel.tdkKenCd;
            // BtoB サイトの場合
            } else {
                ajaxZipCd = this.reqModel.tdkZipCdComp;
                ajaxKenCd = this.reqModel.tdkKenCdComp;
            }
            if (!ajaxZipCd) {
                ajaxZipCd = this.reqModel.kokyakuZip;
                ajaxKenCd = this.reqModel.kokyakuKenCd;
            }
            ajaxReqModel = {
                ajaxFlg:'1',
                hopeDay: day,
                itemTdkList:_this.dataInit.itemTdkList,
                ajaxZipCd: ajaxZipCd,
                ajaxKenCd: ajaxKenCd
            }
            _this.errorMessages = null;//初期化
            axios.post(_this.$UrlConstants.ECSITE +_this.$UrlConstants.SH030 + _this.$UrlConstants.DO_AJAX, ajaxReqModel).then(function(ajaxRespone) {
                _this.reqModel.resultTeikiItemList = ajaxRespone.data.resultTeikiItemList;
                _this.dataInit.hopeTimeList = ajaxRespone.data.hopeTimeList;
                _this.errorMessages = ajaxRespone.data.messages;
                _this.dataInit.shukkaYoteibi = ajaxRespone.data.shukkaYoteibi
                if (_this.reqModel.resultTeikiItemList != null && _this.reqModel.resultTeikiItemList != '') {
                    _this.showTeikiFlg = true;
                    _this.reqModel.teikiFlg = 1;
                } else {
                    _this.showTeikiFlg = false;
                    _this.reqModel.teikiFlg = 0;
                }
                _this.$forceUpdate();
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
                common.scrollTop();
            });
        },
        setAddrValue:function(data){
            var _this = this;
            var idx = data.idx;
            var addr1 = data.addr.ALL_ADDR?data.addr.ALL_ADDR:"";
            
            var kenCd = data.kenCd+"";
            if(idx=="tdk"){
                _this.reqModel.tdkAddr1 = addr1;
                _this.reqModel.tdkKenCd = kenCd;
            } else if(idx=="tdkComp"){
                _this.reqModel.tdkAddr1Comp = addr1;
                _this.reqModel.tdkKenCdComp = kenCd;
            }  else if(idx=="okuriNushi"){
                _this.reqModel.okuriNushiAddr1 = addr1;
                _this.reqModel.okuriNushiKenCd = kenCd;
            } else if(idx=="okuriNushiComp"){
                _this.reqModel.okuriNushiAddr1Comp = addr1;
                _this.reqModel.okuriNushiKenCdComp = kenCd;
            } else {
                _this.reqModel.kokyakuAddr1 = addr1;
                _this.reqModel.kokyakuKenCd = kenCd;
            }
            _this.isCCInputPostalShow = false;
            _this.$forceUpdate();
        },

        //自動発注の配達希望日チェックボックス変更の都度チェックを行う。
        onHopeDayListChange: function() {
            var _this = this;
            if (_this.reqModel.radioGroup1 == '3' && _this.dataInit.displayHanbaiSuuFlg != 0) {
                //配達希望日リストの各日付で日別販売数チェックを行う。
                _this.checkHopeDayList().catch(function() {
                });
            }
        },


        //自動発注 配達希望日リストの各日付で日別販売数チェックを行う。
        checkHopeDayList: function() {
            var _this = this;
            var requestNo = ++_this.hopeDayCheckRequestNo; // 後続で最新のリクエスト番号と一致しない古いリクエスト結果は無視する。
            var hopeDayList = (_this.reqModel.hopeDayList || [])
                .filter(function(hopeDay) {
                    return hopeDay != null && hopeDay != '';
                })
                .slice()
                .sort();

            if (hopeDayList.length == 0) {
                _this.errorMessages = [];
                _this.isCheckingHopeDayList = false;
                return Promise.resolve([]);
            }

            var ajaxZipCd;
            var ajaxKenCd;

            if (_this.dataInit.siteFlg != 1) {
                ajaxZipCd = _this.reqModel.tdkZipCd;
                ajaxKenCd = _this.reqModel.tdkKenCd;
            } else {
                ajaxZipCd = _this.reqModel.tdkZipCdComp;
                ajaxKenCd = _this.reqModel.tdkKenCdComp;
            }

            if (!ajaxZipCd) {
                ajaxZipCd = _this.reqModel.kokyakuZip;
                ajaxKenCd = _this.reqModel.kokyakuKenCd;
            }

            _this.isCheckingHopeDayList = true;

            // 配達希望日リストの各日付で販売数チェックを行い、エラーメッセージを生成する。
            var requestList = hopeDayList.map(function(hopeDay) {
                var ajaxReqModel = {
                    ajaxFlg: '1',
                    hopeDay: hopeDay,
                    itemTdkList: _this.dataInit.itemTdkList,
                    ajaxZipCd: ajaxZipCd,
                    ajaxKenCd: ajaxKenCd
                };

                return axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH030 + _this.$UrlConstants.DO_AJAX, ajaxReqModel).then(function(response) {
                    return {
                        hopeDay: hopeDay,
                        result: response.data || {}
                    };
                });
            });

            return Promise.all(requestList)
                .then(function(resultList) {
                    if (requestNo != _this.hopeDayCheckRequestNo) {
                        return [];
                    }
                    var messages = [];
                    resultList.forEach(function(resultInfo) {
                        var resultMessages = resultInfo.result.messages || [];
                        if (!Array.isArray(resultMessages)) {
                            resultMessages = [resultMessages];
                        }

                        resultMessages.forEach(function(message) {
                            if (message) {
                                var prefix = resultInfo.hopeDay;
                                if (resultInfo.result.shukkaYoteibi) {
                                    prefix += '（出荷予定日：'
                                        + resultInfo.result.shukkaYoteibi
                                        + '）';
                                }
                                messages.push(prefix + '　　' + message);
                            }
                        });
                    });
                    _this.errorMessages = messages;
                    return messages;
                })
                .catch(function(error) {
                    if (requestNo == _this.hopeDayCheckRequestNo) {
                        _this.errorMessages = [];
                        common.errorAPI(error);
                    }
                    return Promise.reject(error);
                })
                .finally(function() {
                    if (requestNo == _this.hopeDayCheckRequestNo) {
                        _this.isCheckingHopeDayList = false;
                    }
                });
        },

        nextPage: function(){
			var _this = this;
			common.clearMessage(_this.listIdErr,"","sh030")
			_this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 20}});
		},
        setAddr:function(idx){
            var _this = this;
            var zip = "";
            if(idx=="tdk"){
                zip =  _this.reqModel.tdkZipCd;
            } else if(idx=="tdkComp"){
                zip =  _this.reqModel.tdkZipCdComp;
            } else if(idx=="okuriNushi"){
                zip =  _this.reqModel.okuriNushiZipCd;
            }else if(idx=="okuriNushiComp"){
                zip =  _this.reqModel.okuriNushiZipCdComp;
            }else {
                zip =  _this.reqModel.kokyakuZip;
            }
            if(!zip) {
                _this.isZipMsgAlert = true;
                _this.zipMsg = _this.$t("sh030.labels.zipCodeIsMandatory");
				return;
			}
            var zipArr = zip.split("-");
            var zip1 = "";
            var zip2 = "";
            if (zipArr.length == 2) {
                zip1 = zipArr[0];
                zip2 = zipArr[1];
            }else{
                zip1 = zip.substr(0,3);
                zip2 = zip.substr(3);
                if(idx=="tdk"){
                    _this.reqModel.tdkZipCd=zip1+"-"+zip2;
                } else if(idx=="tdkComp"){
                    _this.reqModel.tdkZipCdComp=zip1+"-"+zip2;
                } else if(idx=="okuriNushi"){
                    _this.reqModel.okuriNushiZipCd=zip1+"-"+zip2;
                } else if(idx=="okuriNushiComp"){
                    _this.reqModel.okuriNushiZipCdComp=zip1+"-"+zip2;
                } else {
                    _this.reqModel.kokyakuZip=zip1+"-"+zip2;
                }
            }
            var reqModel = {
                idx:idx,
                tdkZip1:zip1,
                tdkZip2:zip2
            }
            _this.$emit("event-loading", true);
            axios.post(_this.$UrlConstants.POPUP +_this.$UrlConstants.CC212 + _this.$UrlConstants.GET_ADDR_INFO, reqModel).then(function(response) {
                if(response.data.kenCd!=undefined) {
                    if(idx=="tdk"){
                        _this.reqModel.tdkKenCd = response.data.kenCd+"";
                    } else if(idx=="tdkComp"){
                        _this.reqModel.tdkKenCdComp = response.data.kenCd+"";
                    } else if(idx=="okuriNushi"){
                        _this.reqModel.okuriNushiKenCd = response.data.kenCd+"";
                    } else if(idx=="okuriNushiComp"){
                        _this.reqModel.okuriNushiKenCdComp = response.data.kenCd+"";
                    } else {
                        _this.reqModel.kokyakuKenCd = response.data.kenCd+"";
                    }

                    if(response.data.allAddr!=""){
                        var allAddr = '';

                        var splAdd = response.data.allAddr.split(",");
                        allAddr = splAdd[0] != null ? splAdd[0]:'';
                        allAddr += splAdd[1] != null ? splAdd[1]:'';
                        allAddr += splAdd[2] != null ? splAdd[2]:'';
                        var addr1 = allAddr;
                        if(idx=="tdk"){
                            //都道府県のプルダウンを使用しない場合
                            if(_this.dataInit.kenPulldownDispFlg == 0){
                                _this.reqModel.tdkAddr1 = response.data.kenNm + addr1;
                            }else{
                                _this.reqModel.tdkAddr1 = addr1;
                            }
                        }  else if(idx=="tdkComp"){
                            //都道府県のプルダウンを使用しない場合
                            if(_this.dataInit.kenPulldownDispFlg == 0){
                                _this.reqModel.tdkAddr1Comp = response.data.kenNm + addr1;
                            }else{
                                _this.reqModel.tdkAddr1Comp = addr1;
                            }
                        } else if (idx=="okuriNushi"){
                            //都道府県のプルダウンを使用しない場合
                            if(_this.dataInit.kenPulldownDispFlg == 0){
                                _this.reqModel.okuriNushiAddr1 = response.data.kenNm + addr1;
                            }else{
                                _this.reqModel.okuriNushiAddr1 = addr1;
                            }
                        } else if (idx=="okuriNushiComp"){
                            //都道府県のプルダウンを使用しない場合
                            if(_this.dataInit.kenPulldownDispFlg == 0){
                                _this.reqModel.okuriNushiAddr1Comp = response.data.kenNm + addr1;
                            }else{
                                _this.reqModel.okuriNushiAddr1Comp = addr1;
                            }
                        }else {
                            //都道府県のプルダウンを使用しない場合
                            if(_this.dataInit.kenPulldownDispFlg == 0){
                                _this.reqModel.kokyakuAddr1 = response.data.kenNm + addr1;
                            }else{
                                _this.reqModel.kokyakuAddr1 = addr1;
                            }
                        }
                    } 
                }
                if(response.data.allAddr==""){
                    _this.isZipMsgAlert = true;
                    _this.zipMsg = _this.$t("sh030.labels.zipCodeDoesNotExist");
                } else if(response.data.allAddr=="juufuku") {
                    _this.openSub(idx, zip1, zip2);
                }

                _this.$emit("event-loading", false);
                _this.$forceUpdate();
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
                common.scrollTop();
            });
        },
        openSub:function(idx, zip1, zip2){
            var _this = this;
            _this.cc212Prop = {
                propTdkZip1:zip1,
                propTdkZip2:zip2,
                propIdx:idx,
            }
            _this.isCCInputPostalShow = true;
        },
        isZipRequiredMsgClose:function(){
            var _this = this;
            _this.isZipMsgAlert = false;
        },
        callMapInfo:function(){
            var _this = this;
            mapInfo.openMapServiceAsp(_this,'setInterval',1);
        },
        setInterval:function(winOpen){
            var _this = this;
            _this.mapInfoResp.winOpen = winOpen;
            _this.mapInfoResp.timer  = setInterval(_this.ifWindowClosed, 1000);
        },
        ifWindowClosed:function(){
            var _this = this;
            if (_this.mapInfoResp.winOpen.closed == true) {
                clearInterval(_this.mapInfoResp.timer);
                // 決済方法の設定
                mapInfo.getReceiptPlace(_this,"setTdkInfoFromMap","1","");
            }
            
        },
        setTdkInfoFromMap(response){
            var _this = this;
            var result = response.data;
            if(result.cancelBtnFlg=="0"){
                _this.mapInfoChangeTdkFlag = true;
                var ajaxReqModel = {
                    ajaxFlg:'2',
                    convCd: result.convCd
                }
                axios.post(_this.$UrlConstants.ECSITE +_this.$UrlConstants.SH030 + _this.$UrlConstants.DO_AJAX, ajaxReqModel).then(function(ajaxRespone) {
                    if(ajaxRespone.data.uketoriSabisuKubun == "4" || ajaxRespone.data.uketoriSabisuKubun == "5") {
                        _this.reqModel.location = result.reqModelstoreName;
                    } else {
                        _this.reqModel.location=result.reqModel.convName + " " + result.reqModel.storeName;
                    }
                }).catch(function(error) {
                    _this.$emit("event-loading", false);
                    common.errorAPI(error);
                    common.scrollTop();
                });
                
                _this.reqModel.orderAddrZip=result.reqModel.postalCode;
                _this.reqModel.orderAddrAddr1=result.reqModel.storeAddress;
                
                _this.reqModel.storeCd=result.reqModel.storeCd;
                _this.reqModel.convCd=result.reqModel.convCd;
                _this.reqModel.convName=result.reqModel.convName;
                _this.reqModel.storeName=result.reqModel.storeName;
                _this.reqModel.officeId=result.reqModel.officeId;
            }
        },
        clearOrderAddr:function(){
            var _this = this;
            _this.mapInfoChangeTdkFlag = false;
            _this.reqModel.location = "";
            _this.reqModel.orderAddrZip="";
            _this.reqModel.orderAddrAddr1="";
                
            _this.reqModel.storeCd="";
            _this.reqModel.convCd="";
            _this.reqModel.convName="";
            _this.reqModel.storeName="";
            _this.reqModel.officeId="";
        },
        selectData(value){
            var _this = this;
            var idx = value.idx;
            var addr1 = value.addr.ADDR?value.addr.ADDR:"";
            var addr2 = value.addr.ADDR2?value.addr.ADDR2:"";
            var kenCd = value.kenCd+"";
            if(idx=="tdk"){
                _this.reqModel.tdkAddr1 = addr1;
                _this.reqModel.tdkAddr2 = addr2;
                _this.reqModel.tdkKenCd = kenCd;
            } else if(idx=="tdkComp"){
                _this.reqModel.tdkAddr1Comp = addr1;
                _this.reqModel.tdkAddr2Comp = addr2;
                _this.reqModel.tdkKenCdComp = kenCd;
            } else if(idx=="okuriNushi"){
                _this.reqModel.okuriNushiAddr1 = addr1;
                _this.reqModel.okuriNushiAddr2 = addr2;
                _this.reqModel.okuriNushiKenCd = kenCd;
            } else if(idx=="okuriNushiComp"){
                _this.reqModel.okuriNushiAddr1Comp = addr1;
                _this.reqModel.okuriNushiAddr2Comp = addr2;
                _this.reqModel.okuriNushiKenCdComp = kenCd;
            } else {
                _this.reqModel.kokyakuAddr1 = addr1;
                _this.reqModel.kokyakuAddr2 = addr2;
                _this.reqModel.kokyakuKenCd = kenCd;
            }
            _this.isCCInputPostalShow = false;
            _this.$forceUpdate();
        },
        /*
        * ラジオボタン選択時
        */
        radioClick:function(){
            this.tdkReset();
            this.$forceUpdate();
            //配送希望日リスト更新
            this.onBlurZipCd();
        },
        /*
        * 代理注文者ラジオボタン選択時
        */
        radioDairiClick:function(value){
            var _this = this;
            if (value == 1) {
                _this.showBetuOrder = false;
                // ログインユーザーをセット
                _this.setValueLoginUser();
                // 届先情報をリセット
                _this.tdkReset();
                _this.cc211Prop = {propKokyakuNo: _this.reqModel.dairiKokyakuNo};
            } else {
                // 届先情報をリセット
                _this.tdkReset();
            }
            this.$forceUpdate();
        },
        /*
        * 届先検索ボタン押下時
        */
        searchTdkList:function(){
            var _this = this;
            _this.cc211Prop = {propKokyakuNo:_this.reqModel.kokyakuNo}
            _this.isSearchTdkList=true;
        },
        searchTdkCompList:function(){
            var _this = this;
            _this.cc211Prop = {propKokyakuNo:_this.reqModel.kokyakuNo}
            _this.isSearchTdkCompList=true;
        },
        /*
        * 送主検索ボタン押下時
        */
        searchOkuriNushiList:function(){
            var _this = this;
            _this.cc211Prop = {propKokyakuNo:_this.reqModel.kokyakuNo}
            _this.isSearchOkurinushiList=true;
        },
        /*
        * 送主検索ボタン押下時
        */
        searchOkuriNushiCompList:function(){
            var _this = this;
            _this.cc211Prop = {propKokyakuNo:_this.reqModel.kokyakuNo}
            _this.isSearchOkurinushiCompList=true;
        },
        /*
        * 代理検索ボタン押下時
        */
        searchDairiList:function(){
            var _this = this;
            _this.isSearchDairiList = true;
        },
        /*
        * 届先情報をセット
        */
        setValueCc211(data){
            var _this = this;
            _this.reqModel.tdkNo = data.value.TDK_NO;
            _this.reqModel.tdkNm1 = data.value.TDK_NM1;
            _this.reqModel.tdkNm2 = data.value.TDK_NM2;
            _this.reqModel.tdkKana1 = data.value.TDK_KANA1;
            _this.reqModel.tdkKana2 = data.value.TDK_KANA2;
            _this.reqModel.tdkZipCd = data.value.TDK_ZIP;
            _this.reqModel.tdkKenCd = data.value.TDK_KEN;
            //都道府県のプルダウンを使用しない場合
            if(_this.dataInit.kenPulldownDispFlg == 0){
                _this.reqModel.tdkAddr1 = data.value.KEN_NM + data.value.TDK_ADDR1;
            }else{
                _this.reqModel.tdkAddr1 = data.value.TDK_ADDR1;
            }
            _this.reqModel.tdkAddr2 = data.value.TDK_ADDR2;
            _this.reqModel.tdkAddr3 = data.value.TDK_ADDR3;
            _this.reqModel.tdkTelNo = data.value.TDK_TEL1;
            _this.reqModel.tdkMail1 = data.value.TDK_MAIL;
            if (data.value.HSTM_KBN != null && data.value.HSTM_KBN != "") {
                _this.reqModel.hopeTime = data.value.HSTM_KBN;
            }
            _this.onBlurZipCd();
        },
        setCompValueCc211(data){
            var _this = this;
            _this.reqModel.tdkNo = data.value.TDK_NO;
            _this.reqModel.tdkNm1Comp = data.value.TDK_NM1;
            _this.reqModel.tdkNm2Comp = data.value.TDK_NM2;
            _this.reqModel.tdkNm3Comp = data.value.TDK_NM3;
            _this.reqModel.tdkKana1Comp = data.value.TDK_KANA1;
            _this.reqModel.tdkKana2Comp = data.value.TDK_KANA2;
            _this.reqModel.tdkZipCdComp = data.value.TDK_ZIP;
            _this.reqModel.tdkKenCdComp = data.value.TDK_KEN;
            //都道府県のプルダウンを使用しない場合
            if(_this.dataInit.kenPulldownDispFlg == 0){
                _this.reqModel.tdkAddr1Comp = data.value.KEN_NM + data.value.TDK_ADDR1;
            }else{
                _this.reqModel.tdkAddr1Comp = data.value.TDK_ADDR1;
            }
            _this.reqModel.tdkAddr2Comp = data.value.TDK_ADDR2;
            _this.reqModel.tdkAddr3Comp = data.value.TDK_ADDR3;
            _this.reqModel.tdkTelNoComp = data.value.TDK_TEL1;
            _this.reqModel.tdkMail1Comp = data.value.TDK_MAIL;
            _this.reqModel.tdkHyoujiKeisyo = data.value.TDK_KEISYOU;
            if (data.value.HSTM_KBN != null && data.value.HSTM_KBN != "") {
                _this.reqModel.hopeTime = data.value.HSTM_KBN;
            }
            _this.reqModel.tdkChokuFlg = data.value.TYOKUSOU_FLG;
            _this.onBlurZipCd();
        },
        /*
        * 送り主BtoC情報をセット
        */
        setOkurinushiValueCc211(data){
            var _this = this;
            _this.reqModel.okuriNushiNo = data.value.TDK_NO;
            _this.reqModel.okuriNushiNm1 = data.value.TDK_NM1;
            _this.reqModel.okuriNushiNm2 = data.value.TDK_NM2;
            _this.reqModel.okuriNushiKana1 = data.value.TDK_KANA1;
            _this.reqModel.okuriNushiKana2 = data.value.TDK_KANA2;
            _this.reqModel.okuriNushiZipCd = data.value.TDK_ZIP;
            _this.reqModel.okuriNushiKenCd = data.value.TDK_KEN;
            
            //都道府県のプルダウンを使用しない場合
            if(_this.dataInit.kenPulldownDispFlg == 0){
                _this.reqModel.okuriNushiAddr1 = data.value.KEN_NM+data.value.TDK_ADDR1;
            }else{
                _this.reqModel.okuriNushiAddr1 = data.value.TDK_ADDR1;
            }
            _this.reqModel.okuriNushiAddr2 = data.value.TDK_ADDR2;
            _this.reqModel.okuriNushiAddr3 = data.value.TDK_ADDR3;
            _this.reqModel.okuriNushiTelNo = data.value.TDK_TEL1;
            _this.reqModel.okuriNushiMail1 = data.value.TDK_MAIL;
            _this.onBlurZipCd();
        },
        /*
        * 送り主BtoB情報をセット
        */
        setOkurinushiCompValueCc211(data){
            var _this = this;
            _this.reqModel.okuriNushiNo = data.value.TDK_NO;
            _this.reqModel.okuriNushiNm1Comp = data.value.TDK_NM1;
            _this.reqModel.okuriNushiNm2Comp = data.value.TDK_NM2;
            _this.reqModel.okuriNushiNm3Comp = data.value.TDK_NM3;
            _this.reqModel.okuriNushiKana1Comp = data.value.TDK_KANA1;
            _this.reqModel.okuriNushiKana2Comp = data.value.TDK_KANA2;
            _this.reqModel.okuriNushiZipCdComp = data.value.TDK_ZIP;
            _this.reqModel.okuriNushiKenCdComp = data.value.TDK_KEN;
            
            //都道府県のプルダウンを使用しない場合
            if(_this.dataInit.kenPulldownDispFlg == 0){
                _this.reqModel.okuriNushiAddr1Comp = data.value.KEN_NM+data.value.TDK_ADDR1;
            }else{
                _this.reqModel.okuriNushiAddr1Comp = data.value.TDK_ADDR1;
            }
            _this.reqModel.okuriNushiAddr2Comp = data.value.TDK_ADDR2;
            _this.reqModel.okuriNushiAddr3Comp = data.value.TDK_ADDR3;
            _this.reqModel.okuriNushiTelNoComp = data.value.TDK_TEL1;
            _this.reqModel.okuriNushiMail1Comp = data.value.TDK_MAIL;
            _this.reqModel.okuriHyoujiKeisyo = data.value.TDK_KEISYOU;
            _this.onBlurZipCd();
        },
        /*
        * 届先情報をリセット
        */
        tdkReset() {
            var _this = this;
            _this.reqModel.tdkNo = "0";
            _this.reqModel.tdkNm1 = "";
            _this.reqModel.tdkNm2 = "";
            _this.reqModel.tdkNm3 = "";
            _this.reqModel.tdkKana1 = "";
            _this.reqModel.tdkKana2 = "";
            _this.reqModel.tdkKana3 = "";
            _this.reqModel.tdkZipCd = "";
            _this.reqModel.tdkKenCd = "";
            _this.reqModel.tdkAddr1 = "";
            _this.reqModel.tdkAddr2 = "";
            _this.reqModel.tdkAddr3 = "";
            _this.reqModel.tdkTelNo = "";
            _this.reqModel.tdkMail1 = "";
            if (_this.dataInit.tdkMyAddrFlg == 1) {
                _this.reqModel.tdkNm1 = _this.reqModel.kokyakuNm1;
                _this.reqModel.tdkNm2 = _this.reqModel.kokyakuNm2;
                _this.reqModel.tdkNm3 = _this.reqModel.kokyakuNm3;
                _this.reqModel.tdkKana1 = _this.reqModel.kokyakuKana1;
                _this.reqModel.tdkKana2 = _this.reqModel.kokyakuKana2;
                _this.reqModel.tdkKana3 = _this.reqModel.kokyakuKana3;
            }

            _this.reqModel.tdkNm1Comp = "";
            _this.reqModel.tdkNm2Comp = "";
            _this.reqModel.tdkNm3Comp = "";
            _this.reqModel.tdkKana1Comp = "";
            _this.reqModel.tdkKana2Comp = "";
            _this.reqModel.tdkZipCdComp = "";
            _this.reqModel.tdkKenCdComp = "";
            _this.reqModel.tdkAddr1Comp = "";
            _this.reqModel.tdkAddr2Comp = "";
            _this.reqModel.tdkAddr3Comp = "";
            _this.reqModel.tdkTelNoComp = "";
            _this.reqModel.tdkMail1Comp = "";
            if (_this.dataInit.tdkKeisyouPullDownFlg == 1){
                if (_this.reqModel.tdkHyoujiKeisyo == ""){
                    _this.reqModel.tdkHyoujiKeisyo = "1";
                }
            }else{
                _this.reqModel.tdkHyoujiKeisyo = "";
            }
            _this.reqModel.tdkChokuFlg = "0";
        },
        /*
        * 代理注文者情報をセット
        */
        setValueCc215(data){
            var _this = this;
            // 届先情報をリセット
            _this.tdkReset();
            _this.showBetuOrder = true;
            _this.reqModel.kokyakuNo = data.value.KOKYAKU_NO;
            _this.reqModel.kokyakuCd = data.value.KOKYAKU_CD;
            _this.reqModel.kokyakuNm1 = data.value.KOKYAKU_NM1;
            _this.reqModel.kokyakuNm2 = data.value.KOKYAKU_NM2;
            _this.reqModel.kokyakuKana1 = data.value.KOKYAKU_KANA1;
            _this.reqModel.kokyakuKana2 = data.value.KOKYAKU_KANA2;
            _this.reqModel.kokyakuZip = data.value.KOKYAKU_ZIP;
            _this.reqModel.kokyakuKenCd = data.value.KOKYAKU_KEN;
            _this.reqModel.kokyakuAddr1 = data.value.KOKYAKU_ADDR1;
            _this.reqModel.kokyakuAddr2 = data.value.KOKYAKU_ADDR2;
            _this.reqModel.kokyakuAddr3 = data.value.KOKYAKU_ADDR3;
            _this.reqModel.kokyakuTel = data.value.KOKYAKU_TEL1;
            _this.reqModel.kokyakuTel2 = data.value.KOKYAKU_TEL2;
            _this.reqModel.kokyakuMail1 = data.value.KOKYAKU_MAIL1;
            _this.reqModel.kokyakuBirth = data.value.KOKYAKU_BIRTH;
            _this.reqModel.kokyakuSexKbn = data.value.KOKYAKU_SEX_KBN;
            _this.reqModel.kokyakuJobKbn = data.value.KOKYAKU_JOB_KBN;
            _this.reqModel.kokyakuFax = data.value.KOKYAKU_FAX;
            _this.onBlurZipCd();
        },
        /*
        * ログインユーザー情報を保持
        */
        setValueDairi(){
            var _this = this;

            _this.reqModel.loginUserKokyakuNo = _this.reqModel.dairiKokyakuNo;
            _this.reqModel.loginUserKokyakuNm1 = _this.reqModel.dairiKokyakuNm1;
            _this.reqModel.loginUserKokyakuNm2 = _this.reqModel.dairiKokyakuNm2;
            _this.reqModel.loginUserKokyakuKana1 = _this.reqModel.dairiKokyakuKana1;
            _this.reqModel.loginUserKokyakuKana2 = _this.reqModel.dairiKokyakuKana2;
            _this.reqModel.loginUserKokyakuZip = _this.reqModel.dairiKokyakuZip;
            _this.reqModel.loginUserKokyakuKenCd = _this.reqModel.dairiKokyakuKenCd;
            _this.reqModel.loginUserKokyakuAddr1 = _this.reqModel.dairiKokyakuAddr1;
            _this.reqModel.loginUserKokyakuAddr2 = _this.reqModel.dairiKokyakuAddr2;
            _this.reqModel.loginUserKokyakuAddr3 = _this.reqModel.dairiKokyakuAddr3;
            _this.reqModel.loginUserKokyakuTelNo = _this.reqModel.dairiKokyakuTelNo;
            _this.reqModel.loginUserKokyakuTelNo2 = _this.reqModel.dairiKokyakuTelNo2;
            _this.reqModel.loginUserKokyakuMail1 = _this.reqModel.dairiKokyakuMail1;
            _this.reqModel.loginUserKokyakuBirth = _this.reqModel.dairiKokyakuBirth;
            _this.reqModel.loginUserKokyakuSexKbn = _this.reqModel.dairiKokyakuSexKbn;
            _this.reqModel.loginUserKokyakuJobKbn = _this.reqModel.dairiKokyakuJobKbn;
            _this.reqModel.loginUserKokyakuFax = _this.reqModel.dairiKokyakuFax;

            _this.reqModel.dairiKokyakuNo = _this.reqModel.kokyakuNo;
            _this.reqModel.dairiKokyakuCd = _this.reqModel.kokyakuCd;
            _this.reqModel.dairiKokyakuNm1 = _this.reqModel.kokyakuNm1;
            _this.reqModel.dairiKokyakuNm2 = _this.reqModel.kokyakuNm2;
            _this.reqModel.dairiKokyakuKana1 = _this.reqModel.kokyakuKana1;
            _this.reqModel.dairiKokyakuKana2 = _this.reqModel.kokyakuKana2;
            _this.reqModel.dairiKokyakuZip = _this.reqModel.kokyakuZip;
            _this.reqModel.dairiKokyakuKenCd = _this.reqModel.kokyakuKenCd;
            _this.reqModel.dairiKokyakuAddr1 = _this.reqModel.kokyakuAddr1;
            _this.reqModel.dairiKokyakuAddr2 = _this.reqModel.kokyakuAddr2;
            _this.reqModel.dairiKokyakuAddr3 = _this.reqModel.kokyakuAddr3;
            _this.reqModel.dairiKokyakuTelNo = _this.reqModel.kokyakuTel;
            _this.reqModel.dairiKokyakuTelNo2 = _this.reqModel.kokyakuTel2;
            _this.reqModel.dairiKokyakuMail1 = _this.reqModel.kokyakuMail1;
            _this.reqModel.dairiKokyakuBirth = _this.reqModel.kokyakuBirth;
            _this.reqModel.dairiKokyakuSexKbn = _this.reqModel.kokyakuSexKbn;
            _this.reqModel.dairiKokyakuJobKbn = _this.reqModel.kokyakuJobKbn;
            _this.reqModel.dairiKokyakuFax = _this.reqModel.kokyakuFax;
        },
        /*
        * ログインユーザー情報をセット
        */
        setValueLoginUser(){
            var _this = this;

            if (_this.reqModel.loginUserKokyakuNo == undefined) {
                _this.reqModel.kokyakuCd = _this.reqModel.dairiKokyakuCd;
                _this.reqModel.kokyakuNo = _this.reqModel.dairiKokyakuNo;
                _this.reqModel.kokyakuNm1 = _this.reqModel.dairiKokyakuNm1;
                _this.reqModel.kokyakuNm2 = _this.reqModel.dairiKokyakuNm2;
                _this.reqModel.kokyakuNm3 = _this.reqModel.dairiKokyakuNm3;
                _this.reqModel.kokyakuKana1 = _this.reqModel.dairiKokyakuKana1;
                _this.reqModel.kokyakuKana2 = _this.reqModel.dairiKokyakuKana2;
                _this.reqModel.kokyakuKana3 = _this.reqModel.dairiKokyakuKana3;
                _this.reqModel.kokyakuZip = _this.reqModel.dairiKokyakuZip;
                _this.reqModel.kokyakuKenCd = _this.reqModel.dairiKokyakuKenCd;
                _this.reqModel.kokyakuAddr1 = _this.reqModel.dairiKokyakuAddr1;
                _this.reqModel.kokyakuAddr2 = _this.reqModel.dairiKokyakuAddr2;
                _this.reqModel.kokyakuAddr3 = _this.reqModel.dairiKokyakuAddr3;
                _this.reqModel.kokyakuTel = _this.reqModel.dairiKokyakuTelNo;
                _this.reqModel.kokyakuTel2 = _this.reqModel.dairiKokyakuTelNo2;
                _this.reqModel.kokyakuMail1 = _this.reqModel.dairiKokyakuMail1;
                _this.reqModel.kokyakuBirth = _this.reqModel.dairiKokyakuBirth;
                _this.reqModel.kokyakuSexKbn = _this.reqModel.dairiKokyakuSexKbn;
                _this.reqModel.kokyakuJobKbn = _this.reqModel.dairiKokyakuJobKbn;
                _this.reqModel.kokyakuFax = _this.reqModel.dairiKokyakuFax;
            } else {
                _this.reqModel.kokyakuCd = "";
                _this.reqModel.kokyakuNo = _this.reqModel.loginUserKokyakuNo;
                _this.reqModel.kokyakuNm1 = _this.reqModel.loginUserKokyakuNm1;
                _this.reqModel.kokyakuNm2 = _this.reqModel.loginUserKokyakuNm2;
                _this.reqModel.kokyakuNm3 = _this.reqModel.loginUserKokyakuNm3;
                _this.reqModel.kokyakuKana1 = _this.reqModel.loginUserKokyakuKana1;
                _this.reqModel.kokyakuKana2 = _this.reqModel.loginUserKokyakuKana2;
                _this.reqModel.kokyakuKana3 = _this.reqModel.loginUserKokyakuKana3;
                _this.reqModel.kokyakuZip = _this.reqModel.loginUserKokyakuZip;
                _this.reqModel.kokyakuKenCd = _this.reqModel.loginUserKokyakuKenCd;
                _this.reqModel.kokyakuAddr1 = _this.reqModel.loginUserKokyakuAddr1;
                _this.reqModel.kokyakuAddr2 = _this.reqModel.loginUserKokyakuAddr2;
                _this.reqModel.kokyakuAddr3 = _this.reqModel.loginUserKokyakuAddr3;
                _this.reqModel.kokyakuTel = _this.reqModel.loginUserKokyakuTelNo;
                _this.reqModel.kokyakuTel2 = _this.reqModel.loginUserKokyakuTelNo2;
                _this.reqModel.kokyakuMail1 = _this.reqModel.loginUserKokyakuMail1;
                _this.reqModel.kokyakuBirth = _this.reqModel.loginUserKokyakuBirth;
                _this.reqModel.kokyakuSexKbn = _this.reqModel.loginUserKokyakuSexKbn;
                _this.reqModel.kokyakuJobKbn = _this.reqModel.loginUserKokyakuJobKbn;
                _this.reqModel.kokyakuFax = _this.reqModel.loginUserKokyakuFax;

                _this.reqModel.dairiKokyakuCd = _this.reqModel.kokyakuCd;
                _this.reqModel.dairiKokyakuNo = _this.reqModel.kokyakuNo;
                _this.reqModel.dairiKokyakuNm1 = _this.reqModel.kokyakuNm1;
                _this.reqModel.dairiKokyakuNm2 = _this.reqModel.kokyakuNm2;
                _this.reqModel.dairiKokyakuNm3 = _this.reqModel.kokyakuNm3;
                _this.reqModel.dairiKokyakuKana1 = _this.reqModel.kokyakuKana1;
                _this.reqModel.dairiKokyakuKana2 = _this.reqModel.kokyakuKana2;
                _this.reqModel.dairiKokyakuKana3 = _this.reqModel.kokyakuKana3;
                _this.reqModel.dairiKokyakuZip = _this.reqModel.kokyakuZip;
                _this.reqModel.dairiKokyakuKenCd = _this.reqModel.kokyakuKenCd;
                _this.reqModel.dairiKokyakuAddr1 = _this.reqModel.kokyakuAddr1;
                _this.reqModel.dairiKokyakuAddr2 = _this.reqModel.kokyakuAddr2;
                _this.reqModel.dairiKokyakuAddr3 = _this.reqModel.kokyakuAddr3;
                _this.reqModel.dairiKokyakuTelNo = _this.reqModel.kokyakuTel;
                _this.reqModel.dairiKokyakuTelNo2 = _this.reqModel.kokyakuTel2;
                _this.reqModel.dairiKokyakuMail1 = _this.reqModel.kokyakuMail1;
                _this.reqModel.kokyakuMail2_confirm = _this.reqModel.loginUserkokyakuMail2_confirm;
                _this.reqModel.dairiKokyakuBirth = _this.reqModel.kokyakuBirth;
                _this.reqModel.dairiKokyakuSexKbn = _this.reqModel.kokyakuSexKbn;
                _this.reqModel.dairiKokyakuJobKbn = _this.reqModel.kokyakuJobKbn;
                _this.reqModel.dairiKokyakuFax = _this.reqModel.kokyakuFax;
            }
        },
        /*
        * 営業所コードから情報を取得
        */
        getYaOfficeInfo:function(){
            var _this = this;
            if(_this.reqModel.tdkAddr2.length < 6){
                return;
            }
            _this.$emit("event-loading", true);
            _this.reqModel.tdkZipCd = "";
            _this.reqModel.tdkKenCd = "";
            _this.reqModel.tdkAddr1 = "";
            _this.reqModel.tdkAddr3 = "";
            var ajaxReqModel = {
                    ajaxFlg:'3',
                    tdkAddr2: _this.reqModel.tdkAddr2,
            }
            axios.post(_this.$UrlConstants.ECSITE +_this.$UrlConstants.SH030 + _this.$UrlConstants.DO_AJAX, ajaxReqModel).then(function(response) {
                _this.reqModel.tdkZipCd = response.data.reqModel.tdkZipCd;
                _this.reqModel.tdkKenCd = response.data.reqModel.tdkKenCd;
                _this.reqModel.tdkAddr1 = response.data.reqModel.tdkAddr1;
                _this.reqModel.tdkAddr2 = response.data.reqModel.tdkAddr2;
                _this.reqModel.tdkAddr3 = response.data.reqModel.tdkAddr3;

                if(response.data.tdkYmdList){
                    _this.dataInit.tdkYmdList = response.data.tdkYmdList;
                    _this.filterTdkDateByItem();
                    _this.initTdkMonths();
                    _this.$forceUpdate();
                }
                
                _this.$emit("event-loading", false);

            }).catch(function(error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
                common.scrollTop();
            });
            
        },

        /*
        * しの情報設定
        */
        doSetShiNo:function(itemCd,qty,itemNm1){
            var tranferdata = {}; 
            tranferdata.reqModel=this.reqModel;
            tranferdata.dataInit=this.dataInit;
            sessionStorage['sh030TranferData'] = JSON.stringify(tranferdata);
            this.$router.push(
                { name: this.SiteConstants.PG010MAIN
                , params: {dispOnly : 0,backPageNo:19,tdkNo:this.reqModel.tdkSeq,itemCd:itemCd,qty:qty,itemNm1:itemNm1,kokyakuNm1:''}
                , query: {pageNo: 26}
                }
            );
        },

        /*
        * スクロール
        * 注文内容確認画面でどの「変更」を押したかによって、スクロールさせる
        */
        scroll:function(scrollNo){
            var scrollId;
            switch(scrollNo) {
                case 1:
                    // 配送希望日時
                    scrollId = 'tdkYmdScroll';
                    break;
                case 2:
                    // ギフト設定
                    scrollId = 'tdkGiftScroll';
                    break;
                case 3:
                    // 送主設定
                    scrollId = 'tdkOkuriScroll';
                    break;
                case 4:
                    // 備考欄
                    scrollId = 'bikoScroll';
                    break;
                default:
                    scrollId = '';
                    break;
            }
            let element = document.getElementById(scrollId);
            if (element != null){
                if(scrollId == 'tdkYmdScroll' || scrollId == 'tdkGiftScroll'){
                    document.getElementById(scrollId).scrollIntoView({block:'center'});
                }else{
                    document.getElementById(scrollId).scrollIntoView();
                }
            }
        },

        getNextTwoMonths(dateStr) {
            const parts = dateStr.split('/');
            const year = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10) - 1;
            const date = new Date(year, month);

            const result = [];
            for (let i = 0; i < 3; i++) {
                let month = date.getMonth() + 1; 
                let year = date.getFullYear();
                result.push(`${year}/${String(month).padStart(2, '0')}`);
                date.setMonth(date.getMonth() + 1); 
            }

            return result;
        },

        getWeeksInMonth(monthStr, index) {
            const parts = monthStr.split('/');
            const year = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10) - 1;
            const firstDayOfMonth = new Date(year, month, 1);
            const lastDayOfMonth = new Date(year, month + 1, 0);

            const weeks = [];
            for (let i = 0; i < 6; i++) {
                weeks.push(new Array(7).fill(null).map(() => ({ val: null, text: null, youbi: null })));
            }

            let currentWeek = 0;
            let dayOfWeek = firstDayOfMonth.getDay();

            for (let day = 1; day <= lastDayOfMonth.getDate(); day++) {
                const dateStr = `${year}/${String(month + 1).padStart(2, '0')}/${String(day).padStart(2, '0')}`;
                weeks[currentWeek][dayOfWeek] = {
                    val: dateStr,
                    text: day,
                    youbi: dayOfWeek,
                    isHoliday: this.holidays.includes(dateStr),
                    canSelect: ((index === 0 && new Date(dateStr) < new Date(this.firstTdkYmd))) ? false : true
                };
                if (dayOfWeek === 6 && day !== lastDayOfMonth.getDate()) {
                    currentWeek++;
                }
                dayOfWeek = (dayOfWeek + 1) % 7;
            }

            return weeks;
        },
        
        containsZenkaku(str) {
            return /[^\x00-\x7F]/.test(str);
        }

    },

    created() {
        var _this = this;
        var queryData = _this.$route.query;
        if (Object.keys(queryData).length > 0) {
            _this.sh060 = queryData;
        }
    },

    computed: {
        radio2Label: function() {
            return this.$t("sh060.labels.designated") +
                (this.isHatchuShow ? this.$t("sh060.labels.onlyOne") : '');
        },
        /*
         * 配達希望日機能の利用可否
         * 配達希望日行の表示、ラジオボタン初期値設定、関連API呼び出しの共通判定に使用する
         * いずれかの条件を満たさない場合は、配達希望日機能を利用しない
         */
        isTdkYmdAvailable: function() {
            return this.dataInit.tdkkibouFlg == 1 && // 配達希望日を表示する
                this.dataInit.cartTeikiFlg == 0 && // 買い方定期商品を含まない
                this.dataInit.cartSplitUseFlg != 1 && // カート分割なし
                this.dataInit.itemTdkYmdErrFlg != 1; // 着日指定不可ではない
        },
        /*
         * お届け先情報テーブルの表示可否
         * radioGroupが配送先情報を表示する状態の場合に、テーブル全体を表示する
         * 配達希望日行の表示可否は、この判定に加えてisTdkYmdAvailableを確認する
         */
        isTdkInfoVisible: function() {
            return (this.reqModel.radioGroup == 1 || // 注文者住所に送る
                this.reqModel.radioGroup == 2 || // 別のお届け先に送る
                this.reqModel.radioGroup == 4); // ヤマト営業所止置きサービスを利用する
        },
        /*
         * 配達希望日行の表示可否
         * お届け先情報テーブルが表示対象で、かつ配送希望日機能を利用できる場合のみ表示する
         * setInitialRadioGroup1、initTdkMonths、hopeDaycでも同じ判定を使用する
         */
        isTdkYmdVisible: function() {
            return this.isTdkInfoVisible && this.isTdkYmdAvailable;
        },
        isHatchuShow: function() {
            let isUpdate = sessionStorage.getItem('oldOrderCd') ? true : false;
            for(var i=0; i<this.dataInit.itemTdkList.length; i++){
                if (this.dataInit.itemTdkList[i].AUTO_HACHU_FLG == '0') {
                    this.autoHatchuFlg = false;
                    break;
                }
            }
            // 自動発注利用する and 新規のみ and 決済方法がクレジット、掛払、代引き and 届先数が1以下のときのみ
            return this.dataInit.autoHatchuOpt == 1 && !isUpdate && ['1', '2', '82' , '6'].includes(this.dataInit.reqModel.kessaiCd) && this.dataInit.tdkCount <= 1 && this.autoHatchuFlg;
        },
    }
}
</script>

<style>
    .dt-col {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .dt-table {
        display: flex;
        flex-direction: column;
        border-top: 1px solid #b59f9f;
        border-left: 1px solid #b59f9f;
        font-size: 12px;
    }

    .dt-row {
        display: flex;
    }

    .dt-cell {
        flex: 1;
        padding: 8px;
        border-bottom: 1px solid #b59f9f;
        border-right: 1px solid #b59f9f;
        justify-content: center;
        height: 1.8rem;
        width: 2.2rem;
        line-height: 0.9rem;
    }

    .sh030-txt-zaiko-warn {
        display: block;
    }
    .error-message-warn {
        display: block;
        color: red;
    }

    .btn:disabled {
        background-color: grey;
        cursor: not-allowed;
    }

</style>

